export const immigrationContent = {
  employmentBased: {
    en: {
      title: "Employment-Based Immigration",
      subtitle: "Secure your American Dream through work-based visa and green card options",
      sections: [
        {
          title: "Work Your Way to Permanent Residency",
          content: "Employment-based immigration offers a pathway to permanent residency for skilled workers, professionals, and investors. Whether you're seeking an H-1B visa, L-1 transfer, or EB green card, we guide you through every step of the complex process."
        },
        {
          title: "Employment Visa Categories",
          items: [
            "H-1B Specialty Occupation Visas",
            "L-1 Intracompany Transferee Visas",
            "O-1 Extraordinary Ability Visas",
            "TN NAFTA Professional Visas",
            "E-2 Treaty Investor Visas",
            "EB-1, EB-2, EB-3 Green Cards"
          ]
        },
        {
          title: "Employment Immigration Services & Key Terms",
          items: [
            "H-1B Specialty Occupation Visa: Temporary work visa for foreign professionals in specialty occupations requiring theoretical or technical expertise",
            "L-1 Visa: Intracompany transferee visa for executives, managers, or employees with specialized knowledge transferring to U.S. office",
            "O-1 Visa: For individuals with extraordinary ability in sciences, arts, education, business, or athletics with national or international acclaim",
            "Labor Certification (PERM): Process where employer demonstrates no qualified U.S. workers available for position before sponsoring foreign worker",
            "EB-1 Visa: First preference employment-based green card for priority workers with extraordinary ability, outstanding professors/researchers, or multinational executives",
            "EB-2 Visa: Second preference for advanced degree professionals or exceptional ability workers, may qualify for National Interest Waiver",
            "EB-3 Visa: Third preference for skilled workers, professionals, and other workers - requires labor certification",
            "EB-5 Investor Visa: Employment-based fifth preference for immigrant investors who invest $800,000-$1,050,000 creating jobs",
            "National Interest Waiver (NIW): Allows EB-2 applicants to skip labor certification if work benefits U.S. national interest",
            "Premium Processing: Optional expedited processing service ($2,500) providing 15-day adjudication for certain visa types",
            "Prevailing Wage Determination: DOL determination of minimum wage employer must pay H-1B workers in specific geographic area",
            "Cap-Subject vs Cap-Exempt: H-1B positions subject to 85,000 annual numerical limit vs positions exempt from cap",
            "AC21 Portability: Allows H-1B workers to change employers or job positions while green card application pending",
            "TN Status: NAFTA/USMCA professional visa for Canadian and Mexican citizens in certain professional occupations",
            "E-2 Treaty Investor: Non-immigrant visa for nationals of treaty countries who invest substantial capital in U.S. business"
          ]
        }
      ],
      faq: [
        {
          question: "What is the H-1B visa lottery?",
          answer: "The H-1B lottery is a random selection process used when applications exceed the annual cap of 65,000 visas (plus 20,000 for advanced degree holders). Your employer must register during the designated period, typically in March."
        },
        {
          question: "Can I change employers on an H-1B visa?",
          answer: "Yes, you can change employers through a process called 'H-1B transfer.' The new employer must file a new H-1B petition, and you can typically start working once it's filed (before approval)."
        }
      ]
    },
    es: {
      title: "Inmigración Basada en Empleo",
      subtitle: "Asegure su Sueño Americano a través de opciones de visa y tarjeta verde basadas en trabajo",
      sections: [
        {
          title: "Trabaje para su Residencia Permanente",
          content: "La inmigración basada en empleo ofrece un camino hacia la residencia permanente para trabajadores calificados, profesionales e inversionistas. Ya sea que busque una visa H-1B, transferencia L-1 o tarjeta verde EB, lo guiamos en cada paso del complejo proceso."
        },
        {
          title: "Categorías de Visa de Empleo",
          items: [
            "Visas H-1B para Ocupaciones Especializadas",
            "Visas L-1 de Transferencia Intracompañía",
            "Visas O-1 de Habilidad Extraordinaria",
            "Visas TN Profesional NAFTA",
            "Visas E-2 de Inversionista por Tratado",
            "Tarjetas Verdes EB-1, EB-2, EB-3"
          ]
        },
        {
          title: "Servicios de Inmigración de Empleo y Términos Clave",
          items: [
            "Visa H-1B de Ocupación Especializada: Visa de trabajo temporal para profesionales extranjeros en ocupaciones especializadas que requieren experiencia teórica o técnica",
            "Visa L-1: Visa de transferencia intracompañía para ejecutivos, gerentes o empleados con conocimiento especializado que se transfieren a oficina en EE.UU.",
            "Visa O-1: Para individuos con habilidad extraordinaria en ciencias, artes, educación, negocios o atletismo con reconocimiento nacional o internacional",
            "Certificación Laboral (PERM): Proceso donde el empleador demuestra que no hay trabajadores estadounidenses calificados disponibles para el puesto antes de patrocinar a trabajador extranjero",
            "Visa EB-1: Tarjeta verde basada en empleo de primera preferencia para trabajadores prioritarios con habilidad extraordinaria, profesores/investigadores destacados o ejecutivos multinacionales",
            "Visa EB-2: Segunda preferencia para profesionales con grado avanzado o habilidad excepcional, puede calificar para Exención de Interés Nacional",
            "Visa EB-3: Tercera preferencia para trabajadores calificados, profesionales y otros trabajadores - requiere certificación laboral",
            "Visa EB-5 de Inversionista: Quinta preferencia basada en empleo para inversionistas inmigrantes que invierten $800,000-$1,050,000 creando empleos",
            "Exención de Interés Nacional (NIW): Permite a solicitantes EB-2 omitir certificación laboral si el trabajo beneficia el interés nacional de EE.UU.",
            "Procesamiento Premium: Servicio opcional de procesamiento acelerado ($2,500) que proporciona adjudicación de 15 días para ciertos tipos de visa",
            "Determinación de Salario Prevaleciente: Determinación del DOL del salario mínimo que el empleador debe pagar a trabajadores H-1B en área geográfica específica",
            "Sujeto al Límite vs Exento del Límite: Posiciones H-1B sujetas al límite numérico anual de 85,000 vs posiciones exentas del límite",
            "Portabilidad AC21: Permite a trabajadores H-1B cambiar de empleador o puesto de trabajo mientras la solicitud de tarjeta verde está pendiente",
            "Estatus TN: Visa profesional NAFTA/USMCA para ciudadanos canadienses y mexicanos en ciertas ocupaciones profesionales",
            "E-2 Inversionista por Tratado: Visa de no inmigrante para nacionales de países con tratado que invierten capital sustancial en negocio de EE.UU."
          ]
        }
      ],
      faq: [
        {
          question: "¿Qué es la lotería de visa H-1B?",
          answer: "La lotería H-1B es un proceso de selección aleatoria usado cuando las solicitudes exceden el límite anual de 65,000 visas (más 20,000 para titulares de grado avanzado). Su empleador debe registrarse durante el período designado, típicamente en marzo."
        },
        {
          question: "¿Puedo cambiar de empleador con una visa H-1B?",
          answer: "Sí, puede cambiar de empleador mediante un proceso llamado 'transferencia H-1B'. El nuevo empleador debe presentar una nueva petición H-1B, y generalmente puede comenzar a trabajar una vez presentada (antes de la aprobación)."
        }
      ]
    },
    vi: {
      title: "Di Trú Dựa Trên Việc Làm",
      subtitle: "Bảo đảm Giấc Mơ Mỹ của bạn thông qua các lựa chọn visa và thẻ xanh dựa trên công việc",
      sections: [
        {
          title: "Làm Việc Để Được Thường Trú",
          content: "Di trú dựa trên việc làm cung cấp con đường đến thường trú cho công nhân lành nghề, chuyên gia và nhà đầu tư. Cho dù bạn đang tìm kiếm visa H-1B, chuyển nhượng L-1 hay thẻ xanh EB, chúng tôi hướng dẫn bạn qua từng bước của quy trình phức tạp."
        },
        {
          title: "Các Loại Visa Việc Làm",
          items: [
            "Visa H-1B Nghề Chuyên Môn",
            "Visa L-1 Chuyển Nhượng Nội Bộ Công Ty",
            "Visa O-1 Khả Năng Phi Thường",
            "Visa TN Chuyên Gia NAFTA",
            "Visa E-2 Nhà Đầu Tư Theo Hiệp Ước",
            "Thẻ Xanh EB-1, EB-2, EB-3"
          ]
        },
        {
          title: "Dịch Vụ Di Trú Việc Làm & Thuật Ngữ Chính",
          items: [
            "Visa H-1B Nghề Chuyên Môn: Visa làm việc tạm thời cho chuyên gia nước ngoài trong nghề chuyên môn yêu cầu chuyên môn lý thuyết hoặc kỹ thuật",
            "Visa L-1: Visa chuyển nhượng nội bộ công ty cho giám đốc điều hành, quản lý hoặc nhân viên có kiến thức chuyên môn chuyển đến văn phòng Mỹ",
            "Visa O-1: Dành cho cá nhân có khả năng phi thường trong khoa học, nghệ thuật, giáo dục, kinh doanh hoặc thể thao với danh tiếng quốc gia hoặc quốc tế",
            "Chứng Nhận Lao Động (PERM): Quy trình mà chủ lao động chứng minh không có công nhân Mỹ đủ điều kiện cho vị trí trước khi bảo lãnh công nhân nước ngoài",
            "Visa EB-1: Thẻ xanh dựa trên việc làm ưu tiên thứ nhất cho công nhân ưu tiên với khả năng phi thường, giáo sư/nhà nghiên cứu xuất sắc hoặc giám đốc điều hành đa quốc gia",
            "Visa EB-2: Ưu tiên thứ hai cho chuyên gia bằng cấp cao hoặc khả năng đặc biệt, có thể đủ điều kiện cho Miễn Trừ Lợi Ích Quốc Gia",
            "Visa EB-3: Ưu tiên thứ ba cho công nhân lành nghề, chuyên gia và công nhân khác - yêu cầu chứng nhận lao động",
            "Visa EB-5 Nhà Đầu Tư: Ưu tiên thứ năm dựa trên việc làm cho nhà đầu tư nhập cư đầu tư $800,000-$1,050,000 tạo việc làm",
            "Miễn Trừ Lợi Ích Quốc Gia (NIW): Cho phép người nộp đơn EB-2 bỏ qua chứng nhận lao động nếu công việc có lợi cho lợi ích quốc gia Mỹ",
            "Xử Lý Ưu Tiên: Dịch vụ xử lý nhanh tùy chọn ($2,500) cung cấp phán quyết trong 15 ngày cho một số loại visa",
            "Xác Định Lương Phổ Biến: Xác định của DOL về lương tối thiểu mà chủ lao động phải trả cho công nhân H-1B ở khu vực địa lý cụ thể",
            "Thuộc Hạn Mức vs Miễn Hạn Mức: Vị trí H-1B thuộc giới hạn số lượng hàng năm 85,000 vs vị trí được miễn hạn mức",
            "Tính Di Động AC21: Cho phép công nhân H-1B đổi chủ lao động hoặc vị trí công việc trong khi đơn xin thẻ xanh đang chờ xử lý",
            "Tình Trạng TN: Visa chuyên gia NAFTA/USMCA cho công dân Canada và Mexico trong một số nghề chuyên môn",
            "E-2 Nhà Đầu Tư Theo Hiệp Ước: Visa không nhập cư cho công dân các quốc gia có hiệp ước đầu tư vốn đáng kể vào doanh nghiệp Mỹ"
          ]
        }
      ],
      faq: [
        {
          question: "Xổ số visa H-1B là gì?",
          answer: "Xổ số H-1B là quy trình chọn ngẫu nhiên được sử dụng khi đơn xin vượt quá hạn mức hàng năm 65,000 visa (cộng 20,000 cho người có bằng cao cấp). Nhà tuyển dụng của bạn phải đăng ký trong thời gian được chỉ định, thường là vào tháng Ba."
        },
        {
          question: "Tôi có thể đổi nhà tuyển dụng với visa H-1B không?",
          answer: "Có, bạn có thể đổi nhà tuyển dụng thông qua quy trình gọi là 'chuyển nhượng H-1B'. Nhà tuyển dụng mới phải nộp đơn H-1B mới, và bạn thường có thể bắt đầu làm việc khi đã nộp (trước khi được phê duyệt)."
        }
      ]
    }
  },
  familyBased: {
    en: {
      title: "Family-Based Immigration",
      subtitle: "Reunite with loved ones through family-based immigration petitions",
      sections: [
        {
          title: "Reunite with Loved Ones",
          content: "Family is at the heart of U.S. immigration law. If you're a U.S. citizen or lawful permanent resident, you may be eligible to sponsor certain family members for green cards. At Daniel Albert Law Firm, we help families navigate the family-based immigration process with clarity and compassion."
        },
        {
          title: "Who Can You Sponsor?",
          content: "U.S. citizens can sponsor immediate relatives (spouses, unmarried children under 21, and parents) as well as other family members. Lawful permanent residents can sponsor spouses and unmarried children. We'll help you understand eligibility requirements and guide you through the petition process."
        },
        {
          title: "Our Services Include",
          items: [
            "Filing Form I-130 (Petition for Alien Relative)",
            "Preparing supporting documentation",
            "Attending interviews with you",
            "Handling consular processing or adjustment of status",
            "Addressing any complications that arise during the process"
          ]
        },
        {
          title: "Family Immigration Services & Key Terms",
          items: [
            "Family-Based Immigration: Family-sponsored immigration process for U.S. citizens or lawful permanent residents to sponsor eligible relatives for green cards",
            "Lawful Permanent Resident (LPR): Foreign national legally and permanently residing in the U.S., also known as a green card holder",
            "Adjustment of Status: Process for individuals already in the U.S. on a non-immigrant visa to apply for permanent resident status",
            "Affidavit of Support: Legal document signed by a sponsor to financially support the immigrant and prevent them from becoming a public charge",
            "Birthright Citizenship: Principle based on the 14th Amendment that anyone born in the U.S. is automatically a citizen, regardless of parents' immigration status",
            "Immediate Relatives: Spouses, minor children, and parents of U.S. citizens, who are not subject to annual numerical limits",
            "Family Preference Categories: Unmarried adult children (F1), spouses and children of LPRs (F2), married children of citizens (F3), and siblings of adult citizens (F4)",
            "Immigration and Nationality Act (INA): The foundational law governing U.S. immigration, including family-based provisions",
            "Diversity Immigrant Visa Program: Lottery-based program offering green cards to individuals from countries with low immigration rates to the U.S.",
            "Per-Country Ceilings: Limits on the number of immigrants from any single country, set at 7% of total family and employment-based visas",
            "I-130 Petition: The form filed by a U.S. citizen or LPR to sponsor a relative for immigration",
            "Conditional Permanent Resident: Status granted to certain spouses or investors, valid for two years and requiring removal of conditions to maintain residency",
            "Public Charge Rule: Regulation assessing whether an immigrant is likely to depend on government assistance, affecting admissibility",
            "Chain Migration: Process where an immigrant sponsors family members, who may later sponsor their own relatives",
            "Sponsor: The U.S. citizen or LPR who files the petition and assumes financial responsibility for the immigrant"
          ]
        }
      ],
      faq: [
        {
          question: "How long does family-based immigration take?",
          answer: "Processing times vary depending on the relationship and visa category. Immediate relatives of U.S. citizens typically have shorter wait times (8-14 months), while other family preference categories may take several years due to visa backlogs."
        },
        {
          question: "What documents do I need?",
          answer: "Common documents include proof of relationship (birth certificates, marriage certificates), proof of U.S. citizenship or permanent residence, financial documents (Affidavit of Support), and identity documents. We'll provide a complete checklist for your specific case."
        }
      ]
    },
    es: {
      title: "Inmigración Basada en Familia",
      subtitle: "Reúnase con sus seres queridos a través de peticiones de inmigración familiar",
      sections: [
        {
          title: "Reúnase con sus Seres Queridos",
          content: "La familia está en el corazón de la ley de inmigración de EE.UU. Si es ciudadano estadounidense o residente permanente legal, puede ser elegible para patrocinar a ciertos miembros de la familia para tarjetas verdes. En Daniel Albert Law Firm, ayudamos a las familias a navegar el proceso de inmigración familiar con claridad y compasión."
        },
        {
          title: "¿A Quién Puede Patrocinar?",
          content: "Los ciudadanos estadounidenses pueden patrocinar a familiares inmediatos (cónyuges, hijos solteros menores de 21 años y padres), así como a otros miembros de la familia. Los residentes permanentes legales pueden patrocinar a cónyuges e hijos solteros. Le ayudaremos a comprender los requisitos de elegibilidad y lo guiaremos a través del proceso de petición."
        },
        {
          title: "Nuestros Servicios Incluyen",
          items: [
            "Presentación del Formulario I-130 (Petición para Familiar Extranjero)",
            "Preparación de documentación de respaldo",
            "Asistir a entrevistas con usted",
            "Manejo del procesamiento consular o ajuste de estatus",
            "Abordar cualquier complicación que surja durante el proceso"
          ]
        },
        {
          title: "Servicios de Inmigración Familiar y Términos Clave",
          items: [
            "Inmigración Basada en Familia: Proceso de inmigración patrocinado por la familia para que ciudadanos estadounidenses o residentes permanentes legales patrocinen familiares elegibles para tarjetas verdes",
            "Residente Permanente Legal (LPR): Nacional extranjero que reside legal y permanentemente en EE.UU., también conocido como titular de tarjeta verde",
            "Ajuste de Estatus: Proceso para individuos ya en EE.UU. con visa de no inmigrante para solicitar estatus de residente permanente",
            "Declaración Jurada de Apoyo: Documento legal firmado por un patrocinador para apoyar financieramente al inmigrante y evitar que se convierta en carga pública",
            "Ciudadanía por Nacimiento: Principio basado en la 14ª Enmienda de que cualquier persona nacida en EE.UU. es automáticamente ciudadana, independientemente del estatus migratorio de los padres",
            "Familiares Inmediatos: Cónyuges, hijos menores y padres de ciudadanos estadounidenses, que no están sujetos a límites numéricos anuales",
            "Categorías de Preferencia Familiar: Hijos adultos solteros (F1), cónyuges e hijos de LPR (F2), hijos casados de ciudadanos (F3) y hermanos de ciudadanos adultos (F4)",
            "Ley de Inmigración y Nacionalidad (INA): La ley fundamental que rige la inmigración estadounidense, incluidas las disposiciones basadas en la familia",
            "Programa de Visa de Inmigrante por Diversidad: Programa basado en lotería que ofrece tarjetas verdes a individuos de países con bajas tasas de inmigración a EE.UU.",
            "Límites por País: Límites en el número de inmigrantes de un solo país, establecidos en 7% del total de visas familiares y basadas en empleo",
            "Petición I-130: El formulario presentado por un ciudadano estadounidense o LPR para patrocinar a un familiar para inmigración",
            "Residente Permanente Condicional: Estatus otorgado a ciertos cónyuges o inversionistas, válido por dos años y que requiere eliminación de condiciones para mantener la residencia",
            "Regla de Carga Pública: Regulación que evalúa si es probable que un inmigrante dependa de asistencia gubernamental, afectando la admisibilidad",
            "Migración en Cadena: Proceso en el que un inmigrante patrocina a miembros de la familia, quienes posteriormente pueden patrocinar a sus propios familiares",
            "Patrocinador: El ciudadano estadounidense o LPR que presenta la petición y asume la responsabilidad financiera por el inmigrante"
          ]
        }
      ],
      faq: [
        {
          question: "¿Cuánto tiempo toma la inmigración basada en familia?",
          answer: "Los tiempos de procesamiento varían según la relación y la categoría de visa. Los familiares inmediatos de ciudadanos estadounidenses generalmente tienen tiempos de espera más cortos (8-14 meses), mientras que otras categorías de preferencia familiar pueden tomar varios años debido a los retrasos de visas."
        },
        {
          question: "¿Qué documentos necesito?",
          answer: "Los documentos comunes incluyen prueba de relación (certificados de nacimiento, certificados de matrimonio), prueba de ciudadanía estadounidense o residencia permanente, documentos financieros (Declaración Jurada de Apoyo) y documentos de identidad. Le proporcionaremos una lista de verificación completa para su caso específico."
        }
      ]
    },
    vi: {
      title: "Di Trú Dựa Trên Gia Đình",
      subtitle: "Đoàn tụ với người thân thông qua đơn xin di trú dựa trên gia đình",
      sections: [
        {
          title: "Đoàn Tụ Với Người Thân",
          content: "Gia đình là trọng tâm của luật di trú Hoa Kỳ. Nếu bạn là công dân Hoa Kỳ hoặc thường trú nhân hợp pháp, bạn có thể đủ điều kiện bảo lãnh một số thành viên gia đình để nhận thẻ xanh. Tại Daniel Albert Law Firm, chúng tôi giúp các gia đình điều hướng quy trình di trú dựa trên gia đình một cách rõ ràng và thấu hiểu."
        },
        {
          title: "Bạn Có Thể Bảo Lãnh Ai?",
          content: "Công dân Hoa Kỳ có thể bảo lãnh người thân trực tiếp (vợ/chồng, con chưa kết hôn dưới 21 tuổi và cha mẹ) cũng như các thành viên gia đình khác. Thường trú nhân hợp pháp có thể bảo lãnh vợ/chồng và con chưa kết hôn. Chúng tôi sẽ giúp bạn hiểu các yêu cầu đủ điều kiện và hướng dẫn bạn qua quy trình đơn."
        },
        {
          title: "Dịch Vụ Của Chúng Tôi Bao Gồm",
          items: [
            "Nộp Mẫu I-130 (Đơn Xin Cho Người Thân Nước Ngoài)",
            "Chuẩn bị tài liệu hỗ trợ",
            "Tham dự phỏng vấn cùng bạn",
            "Xử lý tiến trình lãnh sự hoặc điều chỉnh tình trạng",
            "Giải quyết mọi vấn đề phát sinh trong quá trình"
          ]
        },
        {
          title: "Dịch Vụ Di Trú Gia Đình & Thuật Ngữ Chính",
          items: [
            "Di Trú Dựa Trên Gia Đình: Quy trình di trú được gia đình bảo lãnh cho công dân Hoa Kỳ hoặc thường trú nhân hợp pháp bảo lãnh người thân đủ điều kiện cho thẻ xanh",
            "Thường Trú Nhân Hợp Pháp (LPR): Công dân nước ngoài cư trú hợp pháp và thường xuyên tại Hoa Kỳ, còn được gọi là người có thẻ xanh",
            "Điều Chỉnh Tình Trạng: Quy trình cho các cá nhân đã ở Hoa Kỳ với visa không di trú để xin tình trạng thường trú",
            "Tờ Khai Hỗ Trợ: Tài liệu pháp lý do người bảo lãnh ký để hỗ trợ tài chính cho người nhập cư và ngăn họ trở thành gánh nặng công cộng",
            "Quyền Công Dân Theo Quyền Sinh: Nguyên tắc dựa trên Tu Chính Án thứ 14 rằng bất kỳ ai sinh ra ở Hoa Kỳ đều tự động là công dân, bất kể tình trạng di trú của cha mẹ",
            "Người Thân Trực Tiếp: Vợ/chồng, con nhỏ và cha mẹ của công dân Hoa Kỳ, không bị giới hạn số lượng hàng năm",
            "Loại Ưu Tiên Gia Đình: Con trưởng thành chưa kết hôn (F1), vợ/chồng và con của LPR (F2), con đã kết hôn của công dân (F3) và anh chị em của công dân trưởng thành (F4)",
            "Đạo Luật Di Trú và Quốc Tịch (INA): Luật nền tảng điều chỉnh di trú Hoa Kỳ, bao gồm các điều khoản dựa trên gia đình",
            "Chương Trình Visa Di Trú Đa Dạng: Chương trình dựa trên xổ số cung cấp thẻ xanh cho các cá nhân từ các quốc gia có tỷ lệ di trú thấp đến Hoa Kỳ",
            "Giới Hạn Theo Quốc Gia: Giới hạn số lượng người nhập cư từ bất kỳ quốc gia nào, được đặt ở mức 7% tổng số visa dựa trên gia đình và việc làm",
            "Đơn I-130: Mẫu đơn do công dân Hoa Kỳ hoặc LPR nộp để bảo lãnh người thân cho di trú",
            "Thường Trú Nhân Có Điều Kiện: Tình trạng được cấp cho một số vợ/chồng hoặc nhà đầu tư, có hiệu lực trong hai năm và yêu cầu loại bỏ các điều kiện để duy trì cư trú",
            "Quy Tắc Gánh Nặng Công Cộng: Quy định đánh giá liệu người nhập cư có khả năng phụ thuộc vào hỗ trợ của chính phủ hay không, ảnh hưởng đến khả năng được chấp nhận",
            "Di Trú Chuỗi: Quy trình trong đó một người nhập cư bảo lãnh các thành viên gia đình, những người sau đó có thể bảo lãnh người thân của họ",
            "Người Bảo Lãnh: Công dân Hoa Kỳ hoặc LPR nộp đơn và chịu trách nhiệm tài chính cho người nhập cư"
          ]
        }
      ],
      faq: [
        {
          question: "Di trú dựa trên gia đình mất bao lâu?",
          answer: "Thời gian xử lý khác nhau tùy thuộc vào mối quan hệ và loại visa. Người thân trực tiếp của công dân Hoa Kỳ thường có thời gian chờ ngắn hơn (8-14 tháng), trong khi các loại ưu tiên gia đình khác có thể mất vài năm do tồn đọng visa."
        },
        {
          question: "Tôi cần những tài liệu gì?",
          answer: "Các tài liệu phổ biến bao gồm bằng chứng về mối quan hệ (giấy khai sinh, giấy chứng nhận kết hôn), bằng chứng về quyền công dân Hoa Kỳ hoặc thường trú, tài liệu tài chính (Tờ Khai Hỗ Trợ), và tài liệu nhận dạng. Chúng tôi sẽ cung cấp danh sách kiểm tra đầy đủ cho trường hợp cụ thể của bạn."
        }
      ]
    }
  },
  deportationDefense: {
    en: {
      title: "Deportation & Removal Defense",
      subtitle: "Fight to stay in the United States with aggressive immigration defense",
      sections: [
        {
          title: "Defend Your Right to Stay",
          content: "Facing deportation is one of the most stressful situations an immigrant can face. Our experienced attorneys provide aggressive defense in immigration court, exploring every available option to keep you and your family in the United States."
        },
        {
          title: "Defense Strategies",
          items: [
            "Cancellation of Removal",
            "Asylum Applications in Court",
            "Adjustment of Status Defense",
            "Waivers of Inadmissibility",
            "Appeals to Board of Immigration Appeals (BIA)",
            "Motions to Reopen or Reconsider"
          ]
        },
        {
          title: "Deportation Defense Services & Key Terms",
          items: [
            "Notice to Appear (NTA): Formal charging document initiating removal proceedings specifying grounds of removability",
            "Removal Proceedings: Formal court process where immigration judge determines whether individual should be removed from U.S.",
            "Cancellation of Removal: Relief allowing certain non-permanent residents and LPRs to avoid deportation based on hardship and good moral character",
            "Voluntary Departure: Alternative to removal order allowing individual to leave U.S. at own expense, avoiding formal deportation",
            "Bond Hearing: Immigration court hearing to determine if detained individual should be released on bond pending removal proceedings",
            "Master Calendar Hearing: Initial court appearance where charges reviewed, relief applications filed, and trial dates set",
            "Individual Hearing (Merits Hearing): Trial where evidence presented and immigration judge makes final removal determination",
            "Board of Immigration Appeals (BIA): Administrative appellate body reviewing immigration judge decisions",
            "Motion to Reopen: Request to immigration court to reconsider case based on new facts or changed circumstances",
            "Motion to Reconsider: Request arguing immigration judge made legal or factual error in decision",
            "Stay of Removal: Temporary halt to deportation allowing individual to remain in U.S. while pursuing appeals or other relief",
            "Prosecutorial Discretion: ICE authority to prioritize certain cases and defer action on others",
            "In Absentia Order: Removal order issued when individual fails to appear for immigration court hearing",
            "Withholding of Removal: Protection from deportation to specific country where life or freedom would be threatened",
            "Convention Against Torture (CAT): International treaty providing protection from removal to countries where torture likely"
          ]
        }
      ],
      faq: [
        {
          question: "What should I do if I receive a Notice to Appear?",
          answer: "Contact an immigration attorney immediately. A Notice to Appear (NTA) starts removal proceedings. Time is critical - you'll have a court date and need to prepare your defense strategy right away."
        },
        {
          question: "Can I work while in removal proceedings?",
          answer: "It depends on your immigration status. If you have a valid work permit (EAD), you can continue working. However, if you're out of status, you generally cannot work legally during proceedings unless you apply for and receive work authorization."
        }
      ]
    },
    es: {
      title: "Defensa Contra Deportación y Remoción",
      subtitle: "Luche por permanecer en Estados Unidos con defensa de inmigración agresiva",
      sections: [
        {
          title: "Defienda su Derecho a Permanecer",
          content: "Enfrentar la deportación es una de las situaciones más estresantes que un inmigrante puede enfrentar. Nuestros abogados experimentados brindan defensa agresiva en la corte de inmigración, explorando todas las opciones disponibles para mantenerlo a usted y a su familia en Estados Unidos."
        },
        {
          title: "Estrategias de Defensa",
          items: [
            "Cancelación de Remoción",
            "Solicitudes de Asilo en Corte",
            "Defensa de Ajuste de Estatus",
            "Perdones de Inadmisibilidad",
            "Apelaciones ante la Junta de Apelaciones de Inmigración (BIA)",
            "Mociones para Reabrir o Reconsiderar"
          ]
        },
        {
          title: "Servicios de Defensa Contra Deportación y Términos Clave",
          items: [
            "Aviso de Comparecencia (NTA): Documento formal de cargos que inicia procedimientos de remoción especificando causales de remoción",
            "Procedimientos de Remoción: Proceso judicial formal donde juez de inmigración determina si individuo debe ser removido de EE.UU.",
            "Cancelación de Remoción: Alivio que permite a ciertos no residentes permanentes y LPR evitar deportación basado en dificultad y buen carácter moral",
            "Salida Voluntaria: Alternativa a orden de remoción que permite al individuo salir de EE.UU. a su propio costo, evitando deportación formal",
            "Audiencia de Fianza: Audiencia en corte de inmigración para determinar si individuo detenido debe ser liberado bajo fianza pendiente procedimientos de remoción",
            "Audiencia de Calendario Maestro: Comparecencia inicial en corte donde se revisan cargos, se presentan solicitudes de alivio y se fijan fechas de juicio",
            "Audiencia Individual (Audiencia de Fondo): Juicio donde se presenta evidencia y juez de inmigración toma determinación final de remoción",
            "Junta de Apelaciones de Inmigración (BIA): Órgano de apelación administrativa que revisa decisiones de jueces de inmigración",
            "Moción para Reabrir: Solicitud a corte de inmigración para reconsiderar caso basado en nuevos hechos o circunstancias cambiadas",
            "Moción para Reconsiderar: Solicitud argumentando que juez de inmigración cometió error legal o de hechos en decisión",
            "Suspensión de Remoción: Detención temporal de deportación que permite al individuo permanecer en EE.UU. mientras persigue apelaciones u otro alivio",
            "Discreción Fiscal: Autoridad de ICE para priorizar ciertos casos y diferir acción en otros",
            "Orden en Ausencia: Orden de remoción emitida cuando individuo no comparece a audiencia de corte de inmigración",
            "Suspensión de Remoción: Protección contra deportación a país específico donde la vida o libertad estaría amenazada",
            "Convención Contra la Tortura (CAT): Tratado internacional que proporciona protección contra remoción a países donde la tortura es probable"
          ]
        }
      ],
      faq: [
        {
          question: "¿Qué debo hacer si recibo un Aviso de Comparecencia?",
          answer: "Contacte a un abogado de inmigración inmediatamente. Un Aviso de Comparecencia (NTA) inicia procedimientos de remoción. El tiempo es crítico: tendrá una fecha de corte y necesita preparar su estrategia de defensa de inmediato."
        },
        {
          question: "¿Puedo trabajar durante procedimientos de remoción?",
          answer: "Depende de su estatus migratorio. Si tiene un permiso de trabajo válido (EAD), puede seguir trabajando. Sin embargo, si está fuera de estatus, generalmente no puede trabajar legalmente durante los procedimientos a menos que solicite y reciba autorización de trabajo."
        }
      ]
    },
    vi: {
      title: "Phòng Thủ Trục Xuất & Di Dời",
      subtitle: "Chiến đấu để ở lại Hoa Kỳ với phòng thủ di trú mạnh mẽ",
      sections: [
        {
          title: "Bảo Vệ Quyền Ở Lại",
          content: "Đối mặt với trục xuất là một trong những tình huống căng thẳng nhất mà người nhập cư có thể gặp phải. Các luật sư giàu kinh nghiệm của chúng tôi cung cấp sự bảo vệ mạnh mẽ tại tòa án di trú, khám phá mọi lựa chọn có sẵn để giữ bạn và gia đình ở Hoa Kỳ."
        },
        {
          title: "Chiến Lược Phòng Thủ",
          items: [
            "Hủy Bỏ Di Dời",
            "Đơn Xin Tị Nạn tại Tòa",
            "Phòng Thủ Điều Chỉnh Tình Trạng",
            "Miễn Trừ Không Được Chấp Nhận",
            "Kháng Cáo lên Hội Đồng Kháng Cáo Di Trú (BIA)",
            "Kiến Nghị Mở Lại hoặc Xem Xét Lại"
          ]
        },
        {
          title: "Dịch Vụ Phòng Thủ Trục Xuất & Thuật Ngữ Chính",
          items: [
            "Thông Báo Xuất Hiện (NTA): Tài liệu buộc tội chính thức bắt đầu thủ tục di dời xác định lý do có thể di dời",
            "Thủ Tục Di Dời: Quy trình tòa án chính thức nơi thẩm phán di trú xác định liệu cá nhân có nên bị di dời khỏi Mỹ",
            "Hủy Bỏ Di Dời: Cứu trợ cho phép một số cư dân không thường trú và LPR tránh trục xuất dựa trên khó khăn và phẩm chất đạo đức tốt",
            "Rời Đi Tự Nguyện: Thay thế cho lệnh di dời cho phép cá nhân rời Mỹ tự chi trả, tránh trục xuất chính thức",
            "Phiên Điều Trần Tại Ngoại: Phiên điều trần tòa án di trú để xác định liệu cá nhân bị giam giữ có nên được thả ra tại ngoại chờ thủ tục di dời",
            "Phiên Điều Trần Lịch Chính: Xuất hiện tại tòa ban đầu nơi các cáo buộc được xem xét, đơn xin cứu trợ được nộp và ngày xét xử được ấn định",
            "Phiên Điều Trần Cá Nhân (Phiên Điều Trần Về Đáng): Phiên tòa nơi bằng chứng được trình bày và thẩm phán di trú đưa ra quyết định di dời cuối cùng",
            "Hội Đồng Kháng Cáo Di Trú (BIA): Cơ quan kháng cáo hành chính xem xét quyết định của thẩm phán di trú",
            "Kiến Nghị Mở Lại: Yêu cầu tòa án di trú xem xét lại vụ án dựa trên sự thật mới hoặc hoàn cảnh thay đổi",
            "Kiến Nghị Xem Xét Lại: Yêu cầu tranh luận thẩm phán di trú đã phạm lỗi pháp lý hoặc thực tế trong quyết định",
            "Hoãn Di Dời: Tạm dừng trục xuất tạm thời cho phép cá nhân ở lại Mỹ trong khi theo đuổi kháng cáo hoặc cứu trợ khác",
            "Quyền Tự Do Công Tố: Thẩm quyền của ICE ưu tiên một số trường hợp nhất định và hoãn hành động đối với những trường hợp khác",
            "Lệnh Vắng Mặt: Lệnh di dời được ban hành khi cá nhân không xuất hiện tại phiên điều trần tòa án di trú",
            "Hoãn Di Dời: Bảo vệ khỏi trục xuất đến quốc gia cụ thể nơi cuộc sống hoặc tự do sẽ bị đe dọa",
            "Công Ước Chống Tra Tấn (CAT): Hiệp ước quốc tế cung cấp bảo vệ khỏi di dời đến các quốc gia nơi tra tấn có khả năng xảy ra"
          ]
        }
      ],
      faq: [
        {
          question: "Tôi nên làm gì nếu nhận được Thông Báo Xuất Hiện?",
          answer: "Liên hệ với luật sư di trú ngay lập tức. Thông Báo Xuất Hiện (NTA) bắt đầu thủ tục di dời. Thời gian là quan trọng - bạn sẽ có ngày ra tòa và cần chuẩn bị chiến lược phòng thủ ngay lập tức."
        },
        {
          question: "Tôi có thể làm việc trong khi đang trong thủ tục di dời không?",
          answer: "Tùy thuộc vào tình trạng di trú của bạn. Nếu bạn có giấy phép làm việc hợp lệ (EAD), bạn có thể tiếp tục làm việc. Tuy nhiên, nếu bạn không có tình trạng hợp pháp, bạn thường không thể làm việc hợp pháp trong thủ tục trừ khi bạn xin và nhận được giấy phép làm việc."
        }
      ]
    }
  },
  waivers: {
    en: {
      title: "Waivers (I-601, I-601A, I-212)",
      subtitle: "Overcome inadmissibility grounds and unlock your path to U.S. residence",
      sections: [
        {
          title: "Overcoming Inadmissibility",
          content: "Being deemed inadmissible can derail your immigration plans. Whether it's due to unlawful presence, criminal convictions, fraud, or other grounds, waivers provide a path forward."
        },
        {
          title: "Waiver Services & Key Terms",
          items: [
            "I-601 Waiver: Application for Waiver of Grounds of Inadmissibility for immigrants outside U.S. or adjusting status",
            "I-601A Provisional Waiver: Allows certain immediate relatives to apply for unlawful presence waiver before departing U.S. for consular processing",
            "I-212 Waiver: Application for Permission to Reapply for Admission after deportation or removal",
            "Extreme Hardship: Standard requiring showing qualifying relative would suffer hardship beyond normal family separation",
            "Qualifying Relative: U.S. citizen or LPR spouse or parent (not children) who would experience extreme hardship",
            "Unlawful Presence: Time spent in U.S. without lawful immigration status triggering 3 or 10-year bars",
            "Three-Year Bar: Ban on returning to U.S. after accruing 180-364 days unlawful presence and departing",
            "Ten-Year Bar: Ban on returning after accruing one year or more unlawful presence and departing",
            "Criminal Grounds of Inadmissibility: Certain crimes including crimes involving moral turpitude, controlled substances, prostitution",
            "Fraud or Misrepresentation: Willfully misrepresenting material fact to obtain immigration benefit",
            "Health-Related Grounds: Communicable diseases, failure to show required vaccinations, or drug abuse/addiction",
            "Public Charge: Ground of inadmissibility if likely to become primarily dependent on government for subsistence",
            "Immigration Violation: Prior removal, previous unlawful presence, or document fraud",
            "212(h) Waiver: Criminal waiver for certain crimes involving moral turpitude and simple possession offenses",
            "212(i) Waiver: Waiver for fraud or willful misrepresentation of material fact"
          ]
        }
      ],
      faq: [
        {
          question: "What is extreme hardship?",
          answer: "Extreme hardship goes beyond the normal hardship of family separation. It includes serious medical conditions, financial devastation, inability to relocate due to family or country conditions, and other extraordinary circumstances."
        }
      ]
    },
    es: {
      title: "Perdones (I-601, I-601A, I-212)",
      subtitle: "Supere causales de inadmisibilidad y desbloquee su camino a la residencia en EE.UU.",
      sections: [
        {
          title: "Superando la Inadmisibilidad",
          content: "Ser considerado inadmisible puede descarrilar sus planes de inmigración. Ya sea por presencia ilegal, condenas penales, fraude u otros motivos, los perdones proporcionan un camino a seguir."
        },
        {
          title: "Servicios de Perdones y Términos Clave",
          items: [
            "Perdón I-601: Solicitud de Perdón de Causales de Inadmisibilidad para inmigrantes fuera de EE.UU. o ajustando estatus",
            "Perdón Provisional I-601A: Permite a ciertos familiares inmediatos solicitar perdón por presencia ilegal antes de salir de EE.UU. para procesamiento consular",
            "Perdón I-212: Solicitud de Permiso para Volver a Solicitar Admisión después de deportación o remoción",
            "Dificultad Extrema: Estándar que requiere demostrar que familiar calificado sufriría dificultad más allá de la separación familiar normal",
            "Familiar Calificado: Cónyuge o padre ciudadano estadounidense o LPR (no hijos) que experimentaría dificultad extrema",
            "Presencia Ilegal: Tiempo pasado en EE.UU. sin estatus migratorio legal que desencadena prohibiciones de 3 o 10 años",
            "Prohibición de Tres Años: Prohibición de regresar a EE.UU. después de acumular 180-364 días de presencia ilegal y partir",
            "Prohibición de Diez Años: Prohibición de regresar después de acumular un año o más de presencia ilegal y partir",
            "Causales Penales de Inadmisibilidad: Ciertos crímenes incluyendo crímenes que involucran depravación moral, sustancias controladas, prostitución",
            "Fraude o Falsa Representación: Tergiversación intencional de hecho material para obtener beneficio migratorio",
            "Causales Relacionadas con la Salud: Enfermedades transmisibles, falta de vacunas requeridas o abuso/adicción a drogas",
            "Carga Pública: Causal de inadmisibilidad si es probable convertirse principalmente dependiente del gobierno para subsistencia",
            "Violación de Inmigración: Remoción previa, presencia ilegal previa o fraude de documentos",
            "Perdón 212(h): Perdón penal para ciertos crímenes que involucran depravación moral y delitos de simple posesión",
            "Perdón 212(i): Perdón por fraude o tergiversación intencional de hecho material"
          ]
        }
      ],
      faq: [
        {
          question: "¿Qué es dificultad extrema?",
          answer: "La dificultad extrema va más allá de la dificultad normal de separación familiar. Incluye condiciones médicas graves, devastación financiera, incapacidad de reubicarse debido a condiciones familiares o del país, y otras circunstancias extraordinarias."
        }
      ]
    },
    vi: {
      title: "Miễn Trừ (I-601, I-601A, I-212)",
      subtitle: "Vượt qua lý do không được nhập cảnh và mở khóa con đường đến cư trú tại Mỹ",
      sections: [
        {
          title: "Vượt Qua Không Được Nhập Cảnh",
          content: "Bị coi là không được nhập cảnh có thể làm trật bánh kế hoạch di trú của bạn. Cho dù đó là do hiện diện bất hợp pháp, án tù hình sự, gian lận hoặc các lý do khác, miễn trừ cung cấp con đường phía trước."
        },
        {
          title: "Dịch Vụ Miễn Trừ & Thuật Ngữ Chính",
          items: [
            "Miễn Trừ I-601: Đơn xin Miễn Trừ Lý Do Không Được Nhập Cảnh cho người nhập cư ở ngoài Mỹ hoặc điều chỉnh tình trạng",
            "Miễn Trừ Tạm Thời I-601A: Cho phép một số người thân trực tiếp nộp đơn miễn trừ hiện diện bất hợp pháp trước khi rời Mỹ để xử lý lãnh sự",
            "Miễn Trừ I-212: Đơn xin Phép Nộp Lại Đơn Xin Nhập Cảnh sau khi bị trục xuất hoặc di dời",
            "Khó Khăn Cực Độ: Tiêu chuẩn yêu cầu chứng minh người thân đủ điều kiện sẽ chịu khó khăn vượt quá sự chia tách gia đình bình thường",
            "Người Thân Đủ Điều Kiện: Vợ/chồng hoặc cha mẹ là công dân Mỹ hoặc LPR (không phải con) sẽ trải qua khó khăn cực độ",
            "Hiện Diện Bất Hợp Pháp: Thời gian ở Mỹ không có tình trạng di trú hợp pháp kích hoạt lệnh cấm 3 hoặc 10 năm",
            "Lệnh Cấm Ba Năm: Lệnh cấm quay lại Mỹ sau khi tích lũy 180-364 ngày hiện diện bất hợp pháp và rời đi",
            "Lệnh Cấm Mười Năm: Lệnh cấm quay lại sau khi tích lũy một năm trở lên hiện diện bất hợp pháp và rời đi",
            "Lý Do Hình Sự Không Được Nhập Cảnh: Một số tội phạm bao gồm tội phạm liên quan đến đạo đức sa đoạ, chất bị kiểm soát, mại dâm",
            "Gian Lận hoặc Tuyên Bố Sai: Cố ý tuyên bố sai sự thật quan trọng để có được lợi ích di trú",
            "Lý Do Liên Quan Đến Sức Khỏe: Bệnh truyền nhiễm, thiếu vắc-xin bắt buộc hoặc lạm dụng/nghiện ma túy",
            "Gánh Nặng Công Cộng: Lý do không được nhập cảnh nếu có khả năng trở thành phụ thuộc chủ yếu vào chính phủ để sinh tồn",
            "Vi Phạm Di Trú: Di dời trước đó, hiện diện bất hợp pháp trước đó hoặc gian lận tài liệu",
            "Miễn Trừ 212(h): Miễn trừ hình sự cho một số tội phạm liên quan đến đạo đức sa đoạ và vi phạm sở hữu đơn giản",
            "Miễn Trừ 212(i): Miễn trừ cho gian lận hoặc tuyên bố sai cố ý về sự thật quan trọng"
          ]
        }
      ],
      faq: [
        {
          question: "Khó khăn cực độ là gì?",
          answer: "Khó khăn cực độ vượt quá khó khăn bình thường của việc chia tách gia đình. Nó bao gồm các tình trạng y tế nghiêm trọng, tàn phá tài chính, không thể di chuyển do điều kiện gia đình hoặc quốc gia, và các trường hợp bất thường khác."
        }
      ]
    }
  },
  daca: {
    en: {
      title: "DACA - Deferred Action for Childhood Arrivals",
      subtitle: "Protection from deportation and work authorization for Dreamers",
      sections: [
        { 
          title: "Protect Your Future with DACA", 
          content: "If you came to the United States as a child and meet certain criteria, you may qualify for DACA. This program provides temporary protection from deportation and work authorization."
        },
        {
          title: "DACA Services & Key Terms",
          items: [
            "Deferred Action: Discretionary determination to defer removal action, not providing lawful status but protecting from deportation",
            "Dreamers: Young undocumented immigrants brought to U.S. as children, often through no fault of their own",
            "Initial DACA Application: First-time application requiring proof of continuous U.S. residence since 2007 and arrival before age 16",
            "DACA Renewal: Application to extend DACA and work authorization for additional two years before expiration",
            "Employment Authorization Document (EAD): Work permit issued to DACA recipients valid for two years",
            "Advance Parole: Permission for DACA recipients to travel abroad for humanitarian, educational, or employment purposes",
            "Continuous Residence: Requirement that applicant not depart U.S. for 90+ consecutive days or multiple significant departures",
            "Physical Presence: Requirement that DACA applicant was present in U.S. on June 15, 2012, and at time of application",
            "Educational Requirement: Must be currently in school, graduated high school, obtained GED, or honorably discharged veteran",
            "Age Requirement: Must have been under 31 years old as of June 15, 2012, and at least 15 years old when applying",
            "Criminal Background Check: USCIS conducts biometrics and background check for significant misdemeanors or felonies",
            "Prosecutorial Discretion: DACA is exercise of prosecutorial discretion, can be terminated if recipient poses threat",
            "Two-Year Renewable Period: DACA grants protection and work authorization in renewable two-year increments",
            "No Lawful Status: DACA does not confer lawful immigration status or pathway to permanent residence or citizenship",
            "Public Benefits Restriction: DACA recipients generally ineligible for federal public benefits but may qualify for state benefits"
          ]
        }
      ],
      faq: [
        { 
          question: "Can I travel outside the U.S. with DACA?", 
          answer: "DACA recipients cannot travel internationally without advance parole. You must apply for and receive advance parole before traveling, which is granted for humanitarian, educational, or employment purposes only."
        },
        {
          question: "Does DACA lead to a green card?",
          answer: "No, DACA does not provide a direct pathway to permanent residence. However, DACA recipients may qualify for green cards through other means such as family sponsorship or employment-based visas if eligible."
        }
      ]
    },
    es: {
      title: "DACA - Acción Diferida para los Llegados en la Infancia",
      subtitle: "Protección contra deportación y autorización de trabajo para Dreamers",
      sections: [
        { title: "Proteja su Futuro con DACA", content: "Si llegó a Estados Unidos cuando era niño y cumple ciertos criterios, puede calificar para DACA. Este programa proporciona protección temporal contra la deportación y autorización de trabajo." },
        {
          title: "Servicios DACA y Términos Clave",
          items: [
            "Acción Diferida: Determinación discrecional para diferir acción de remoción, no proporciona estatus legal pero protege contra deportación",
            "Dreamers: Jóvenes inmigrantes indocumentados traídos a EE.UU. cuando eran niños, a menudo sin culpa propia",
            "Solicitud Inicial de DACA: Primera solicitud que requiere prueba de residencia continua en EE.UU. desde 2007 y llegada antes de los 16 años",
            "Renovación de DACA: Solicitud para extender DACA y autorización de trabajo por dos años adicionales antes del vencimiento",
            "Documento de Autorización de Empleo (EAD): Permiso de trabajo emitido a beneficiarios de DACA válido por dos años",
            "Permiso Anticipado: Permiso para beneficiarios de DACA para viajar al extranjero por razones humanitarias, educativas o laborales",
            "Requisito Educativo: Debe estar actualmente en la escuela, haberse graduado de secundaria, obtenido GED o veterano dado de baja honorablemente",
            "Período Renovable de Dos Años: DACA otorga protección y autorización de trabajo en incrementos renovables de dos años"
          ]
        }
      ],
      faq: [
        { question: "¿Puedo viajar fuera de EE.UU. con DACA?", answer: "Los beneficiarios de DACA no pueden viajar internacionalmente sin permiso anticipado. Debe solicitar y recibir permiso anticipado antes de viajar, que se otorga solo por razones humanitarias, educativas o laborales." },
        { question: "¿DACA lleva a una tarjeta verde?", answer: "No, DACA no proporciona un camino directo a la residencia permanente. Sin embargo, los beneficiarios de DACA pueden calificar para tarjetas verdes a través de otros medios como patrocinio familiar o visas basadas en empleo si son elegibles." }
      ]
    },
    vi: {
      title: "DACA - Hoãn Trục Xuất cho Người Đến Khi Còn Nhỏ",
      subtitle: "Bảo vệ khỏi trục xuất và giấy phép làm việc cho Dreamers",
      sections: [
        { title: "Bảo Vệ Tương Lai Của Bạn với DACA", content: "Nếu bạn đến Hoa Kỳ khi còn nhỏ và đáp ứng các tiêu chí nhất định, bạn có thể đủ điều kiện cho DACA. Chương trình này cung cấp bảo vệ tạm thời khỏi trục xuất và giấy phép làm việc." },
        {
          title: "Dịch Vụ DACA & Thuật Ngữ Chính",
          items: [
            "Hoãn Trục Xuất: Quyết định tùy ý để hoãn hành động di dời, không cung cấp tình trạng hợp pháp nhưng bảo vệ khỏi trục xuất",
            "Dreamers: Người nhập cư trẻ không có giấy tờ được đưa đến Mỹ khi còn nhỏ, thường không có lỗi của họ",
            "Đơn DACA Ban Đầu: Đơn lần đầu yêu cầu chứng minh cư trú liên tục tại Mỹ từ 2007 và đến trước 16 tuổi",
            "Gia Hạn DACA: Đơn xin gia hạn DACA và giấy phép làm việc thêm hai năm trước khi hết hạn",
            "Giấy Phép Làm Việc (EAD): Giấy phép làm việc cấp cho người nhận DACA có hiệu lực hai năm",
            "Phép Trước: Cho phép người nhận DACA đi du lịch ra nước ngoài vì mục đích nhân đạo, giáo dục hoặc việc làm",
            "Yêu Cầu Giáo Dục: Phải đang đi học, tốt nghiệp trung học, có GED hoặc cựu chiến binh được xuất ngũ danh dự",
            "Thời Hạn Hai Năm Có Thể Gia Hạn: DACA cấp bảo vệ và giấy phép làm việc theo từng đợt hai năm có thể gia hạn"
          ]
        }
      ],
      faq: [
        { question: "Tôi có thể đi du lịch ra ngoài Mỹ với DACA không?", answer: "Người nhận DACA không thể đi du lịch quốc tế mà không có phép trước. Bạn phải xin và nhận phép trước khi đi du lịch, chỉ được cấp vì mục đích nhân đạo, giáo dục hoặc việc làm." },
        { question: "DACA có dẫn đến thẻ xanh không?", answer: "Không, DACA không cung cấp con đường trực tiếp đến thường trú. Tuy nhiên, người nhận DACA có thể đủ điều kiện cho thẻ xanh thông qua các phương tiện khác như bảo lãnh gia đình hoặc visa dựa trên việc làm nếu đủ điều kiện." }
      ]
    }
  },
  k1Visa: {
    en: { 
      title: "K-1 Fiancé(e) Visa", 
      subtitle: "Bring your fiancé(e) to the U.S. to marry", 
      sections: [
        { 
          title: "K-1 Fiancé Visa Process", 
          content: "The K-1 visa allows U.S. citizens to bring their foreign fiancé(e) to the United States to get married within 90 days. After marriage, your spouse can apply for adjustment of status to become a permanent resident."
        },
        {
          title: "K-1 Visa Services & Key Terms",
          items: [
            "K-1 Nonimmigrant Visa: Fiancé(e) visa allowing foreign national to enter U.S. to marry U.S. citizen petitioner within 90 days",
            "Form I-129F: Petition for Alien Fiancé(e) filed by U.S. citizen with USCIS to initiate K-1 process",
            "Two-Year Relationship Requirement: Couple must have met in person at least once within two years before filing petition",
            "Intent to Marry: Both parties must demonstrate genuine intent to marry within 90 days of fiancé(e) entering U.S.",
            "K-2 Visa: Derivative visa for unmarried children under 21 of K-1 visa holder to accompany or follow parent to U.S.",
            "90-Day Marriage Requirement: K-1 visa holder must marry U.S. citizen petitioner within 90 days of U.S. entry",
            "Adjustment of Status: After marriage, K-1 visa holder files Form I-485 to become lawful permanent resident",
            "Conditional Permanent Residence: Initial green card valid for two years if marriage less than two years old at time of approval",
            "Form I-751: Petition to Remove Conditions on Residence filed jointly by couple within 90 days before two-year anniversary",
            "Medical Examination: K-1 applicants must undergo medical exam by panel physician and meet vaccination requirements",
            "Affidavit of Support (Form I-134): U.S. citizen petitioner must demonstrate financial ability to support fiancé(e)",
            "DS-160: Online Nonimmigrant Visa Application completed by K-1 applicant for consular interview",
            "Consular Interview: Required interview at U.S. embassy/consulate where K-1 applicant establishes relationship bona fides",
            "No Status Change: K-1 visa holders cannot change to another nonimmigrant status and must marry petitioner or depart U.S.",
            "Work Authorization: K-1 visa holders may apply for work authorization (EAD) after entering U.S. while adjustment pending"
          ]
        }
      ],
      faq: [
        {
          question: "How long does the K-1 visa process take?",
          answer: "The K-1 visa process typically takes 6-9 months from filing the I-129F petition to visa approval. Processing times vary by USCIS service center and consular post."
        },
        {
          question: "Can my fiancé(e) work in the U.S. on a K-1 visa?",
          answer: "K-1 visa holders can apply for work authorization after entering the U.S. by filing Form I-765. Once approved, they receive an Employment Authorization Document (EAD) allowing them to work."
        }
      ]
    },
    es: { 
      title: "Visa K-1 de Prometido(a)", 
      subtitle: "Traiga a su prometido(a) a EE.UU. para casarse", 
      sections: [
        { 
          title: "Proceso de Visa K-1 de Prometido", 
          content: "La visa K-1 permite a los ciudadanos estadounidenses traer a su prometido(a) extranjero(a) a Estados Unidos para casarse dentro de 90 días. Después del matrimonio, su cónyuge puede solicitar ajuste de estatus para convertirse en residente permanente."
        },
        {
          title: "Servicios de Visa K-1 y Términos Clave",
          items: [
            "Visa de No Inmigrante K-1: Visa de prometido(a) que permite a nacional extranjero entrar a EE.UU. para casarse con peticionario ciudadano estadounidense dentro de 90 días",
            "Formulario I-129F: Petición para Prometido(a) Extranjero presentada por ciudadano estadounidense con USCIS para iniciar proceso K-1",
            "Requisito de Relación de Dos Años: Pareja debe haberse conocido en persona al menos una vez dentro de dos años antes de presentar petición",
            "Intención de Casarse: Ambas partes deben demostrar intención genuina de casarse dentro de 90 días de entrada del prometido(a) a EE.UU.",
            "Visa K-2: Visa derivada para hijos solteros menores de 21 años del titular de visa K-1 para acompañar o seguir al padre a EE.UU.",
            "Requisito de Matrimonio de 90 Días: Titular de visa K-1 debe casarse con peticionario ciudadano estadounidense dentro de 90 días de entrada a EE.UU.",
            "Ajuste de Estatus: Después del matrimonio, titular de visa K-1 presenta Formulario I-485 para convertirse en residente permanente legal",
            "Residencia Permanente Condicional: Tarjeta verde inicial válida por dos años si matrimonio tiene menos de dos años al momento de aprobación",
            "Formulario I-751: Petición para Remover Condiciones de Residencia presentada conjuntamente por pareja dentro de 90 días antes del segundo aniversario",
            "Examen Médico: Solicitantes K-1 deben someterse a examen médico por médico del panel y cumplir requisitos de vacunación",
            "Declaración Jurada de Apoyo (Formulario I-134): Peticionario ciudadano estadounidense debe demostrar capacidad financiera para apoyar al prometido(a)",
            "DS-160: Solicitud de Visa de No Inmigrante en línea completada por solicitante K-1 para entrevista consular",
            "Entrevista Consular: Entrevista requerida en embajada/consulado de EE.UU. donde solicitante K-1 establece autenticidad de relación",
            "Sin Cambio de Estatus: Titulares de visa K-1 no pueden cambiar a otro estatus de no inmigrante y deben casarse con peticionario o salir de EE.UU.",
            "Autorización de Trabajo: Titulares de visa K-1 pueden solicitar autorización de trabajo (EAD) después de entrar a EE.UU. mientras ajuste está pendiente"
          ]
        }
      ],
      faq: [
        {
          question: "¿Cuánto tiempo toma el proceso de visa K-1?",
          answer: "El proceso de visa K-1 típicamente toma 6-9 meses desde la presentación de la petición I-129F hasta la aprobación de visa. Los tiempos de procesamiento varían según el centro de servicio de USCIS y el puesto consular."
        },
        {
          question: "¿Puede mi prometido(a) trabajar en EE.UU. con una visa K-1?",
          answer: "Los titulares de visa K-1 pueden solicitar autorización de trabajo después de entrar a EE.UU. presentando el Formulario I-765. Una vez aprobado, reciben un Documento de Autorización de Empleo (EAD) que les permite trabajar."
        }
      ]
    },
    vi: { 
      title: "Visa K-1 Hôn Phu/Thê", 
      subtitle: "Đưa hôn phu/thê của bạn đến Mỹ để kết hôn", 
      sections: [
        { 
          title: "Quy Trình Visa K-1", 
          content: "Visa K-1 cho phép công dân Mỹ đưa hôn phu/thê nước ngoài đến Hoa Kỳ để kết hôn trong vòng 90 ngày. Sau khi kết hôn, vợ/chồng của bạn có thể nộp đơn điều chỉnh tình trạng để trở thành thường trú nhân."
        },
        {
          title: "Dịch Vụ Visa K-1 & Thuật Ngữ Chính",
          items: [
            "Visa Không Nhập Cư K-1: Visa hôn phu/thê cho phép công dân nước ngoài nhập cảnh Mỹ để kết hôn với người đệ đơn là công dân Mỹ trong vòng 90 ngày",
            "Mẫu I-129F: Đơn Xin Cho Hôn Phu/Thê Nước Ngoài do công dân Mỹ nộp với USCIS để bắt đầu quy trình K-1",
            "Yêu Cầu Mối Quan Hệ Hai Năm: Cặp đôi phải gặp nhau trực tiếp ít nhất một lần trong hai năm trước khi nộp đơn",
            "Ý Định Kết Hôn: Cả hai bên phải chứng minh ý định chân thành kết hôn trong vòng 90 ngày sau khi hôn phu/thê nhập cảnh Mỹ",
            "Visa K-2: Visa phái sinh cho con chưa kết hôn dưới 21 tuổi của người có visa K-1 để đi cùng hoặc theo cha mẹ đến Mỹ",
            "Yêu Cầu Kết Hôn 90 Ngày: Người có visa K-1 phải kết hôn với người đệ đơn là công dân Mỹ trong vòng 90 ngày sau khi nhập cảnh Mỹ",
            "Điều Chỉnh Tình Trạng: Sau khi kết hôn, người có visa K-1 nộp Mẫu I-485 để trở thành thường trú nhân hợp pháp",
            "Thường Trú Có Điều Kiện: Thẻ xanh ban đầu có hiệu lực hai năm nếu cuộc hôn nhân dưới hai năm tại thời điểm phê duyệt",
            "Mẫu I-751: Đơn Xin Loại Bỏ Điều Kiện Cư Trú do cặp đôi nộp chung trong vòng 90 ngày trước kỷ niệm hai năm",
            "Khám Sức Khỏe: Người nộp đơn K-1 phải khám sức khỏe bởi bác sĩ hội đồng được lãnh sự quán phê duyệt và đáp ứng yêu cầu tiêm chủng",
            "Tờ Khai Hỗ Trợ (Mẫu I-134): Người đệ đơn là công dân Mỹ phải chứng minh khả năng tài chính để hỗ trợ hôn phu/thê",
            "DS-160: Đơn Xin Visa Không Nhập Cư Trực Tuyến do người nộp đơn K-1 hoàn thành cho phỏng vấn lãnh sự",
            "Phỏng Vấn Lãnh Sự: Phỏng vấn bắt buộc tại đại sứ quán/lãnh sự quán Mỹ nơi người nộp đơn K-1 thiết lập tính xác thực của mối quan hệ",
            "Không Đổi Tình Trạng: Người có visa K-1 không thể đổi sang tình trạng không nhập cư khác và phải kết hôn với người đệ đơn hoặc rời Mỹ",
            "Giấy Phép Làm Việc: Người có visa K-1 có thể nộp đơn xin giấy phép làm việc (EAD) sau khi nhập cảnh Mỹ trong khi điều chỉnh đang chờ xử lý"
          ]
        }
      ],
      faq: [
        {
          question: "Quy trình visa K-1 mất bao lâu?",
          answer: "Quy trình visa K-1 thường mất 6-9 tháng từ khi nộp đơn I-129F đến khi visa được phê duyệt. Thời gian xử lý khác nhau tùy theo trung tâm dịch vụ USCIS và cơ quan lãnh sự."
        },
        {
          question: "Hôn phu/thê của tôi có thể làm việc ở Mỹ với visa K-1 không?",
          answer: "Người có visa K-1 có thể nộp đơn xin giấy phép làm việc sau khi nhập cảnh Mỹ bằng cách nộp Mẫu I-765. Sau khi được phê duyệt, họ nhận được Giấy Phép Làm Việc (EAD) cho phép họ làm việc."
        }
      ]
    }
  },
  asylum: {
    en: { 
      title: "Asylum Services", 
      subtitle: "Protection for those fleeing persecution", 
      sections: [
        { 
          title: "Asylum Applications", 
          content: "If you face persecution in your home country due to race, religion, nationality, political opinion, or membership in a particular social group, you may qualify for asylum. Asylum provides protection and a pathway to permanent residence."
        },
        {
          title: "Asylum Services & Key Terms",
          items: [
            "Asylum: Protection granted to foreign nationals in U.S. unable or unwilling to return home due to persecution or well-founded fear",
            "Refugee: Person outside U.S. seeking protection, while asylee is person in U.S. or at port of entry seeking protection",
            "Well-Founded Fear: Subjectively genuine and objectively reasonable fear of persecution based on credible evidence",
            "Persecution: Harm or suffering inflicted on individual because of protected characteristic, must be by government or group government unable/unwilling to control",
            "Protected Grounds: Race, religion, nationality, political opinion, or membership in particular social group",
            "Particular Social Group: Group sharing common immutable characteristic or fundamental right such as gender, sexual orientation, or family ties",
            "One-Year Filing Deadline: Asylum application must be filed within one year of arrival unless extraordinary circumstances or changed circumstances",
            "Affirmative Asylum: Application filed with USCIS by person not in removal proceedings, includes interview with asylum officer",
            "Defensive Asylum: Application filed with immigration court as defense to removal, decided by immigration judge",
            "Credible Fear Interview: Initial screening for arriving aliens claiming asylum, establishes significant possibility of establishing asylum eligibility",
            "Reasonable Fear Interview: Screening for previously removed individuals or certain aggravated felons seeking withholding of removal or CAT protection",
            "Form I-589: Application for Asylum and for Withholding of Removal, principal asylum application form",
            "Derivative Asylum: Spouse and unmarried children under 21 may be included in principal's asylum application or added later",
            "Employment Authorization: Asylum applicants may apply for work permit 150 days after filing complete asylum application",
            "Path to Green Card: Asylees may apply for permanent residence one year after being granted asylum status"
          ]
        }
      ],
      faq: [
        {
          question: "What is the difference between asylum and refugee status?",
          answer: "Both provide protection from persecution, but refugees apply from outside the U.S. before arrival, while asylum seekers apply after arriving in the U.S. or at a port of entry."
        },
        {
          question: "Can I work while my asylum application is pending?",
          answer: "You may apply for an Employment Authorization Document (EAD) 150 days after filing your complete asylum application. USCIS has 30 days to adjudicate the EAD application."
        }
      ]
    },
    es: { 
      title: "Servicios de Asilo", 
      subtitle: "Protección para quienes huyen de persecución", 
      sections: [
        { title: "Solicitudes de Asilo", content: "Si enfrenta persecución en su país de origen por raza, religión, nacionalidad, opinión política o pertenencia a un grupo social particular, puede calificar para asilo. El asilo proporciona protección y un camino hacia la residencia permanente." },
        {
          title: "Servicios de Asilo y Términos Clave",
          items: [
            "Asilo: Protección otorgada a nacionales extranjeros en EE.UU. que no pueden o no quieren regresar a casa debido a persecución o temor fundado",
            "Temor Fundado: Temor subjetivamente genuino y objetivamente razonable de persecución basado en evidencia creíble",
            "Fecha Límite de Un Año: Solicitud de asilo debe presentarse dentro de un año de llegada a menos que circunstancias extraordinarias",
            "Asilo Afirmativo: Solicitud presentada con USCIS por persona que no está en procedimientos de remoción",
            "Asilo Defensivo: Solicitud presentada con corte de inmigración como defensa contra remoción",
            "Formulario I-589: Solicitud de Asilo y de Suspensión de Remoción"
          ]
        }
      ],
      faq: [
        { question: "¿Cuál es la diferencia entre asilo y estatus de refugiado?", answer: "Ambos proporcionan protección contra persecución, pero los refugiados solicitan desde fuera de EE.UU. antes de llegar, mientras que los solicitantes de asilo solicitan después de llegar a EE.UU. o en un puerto de entrada." },
        { question: "¿Puedo trabajar mientras mi solicitud de asilo está pendiente?", answer: "Puede solicitar un Documento de Autorización de Empleo (EAD) 150 días después de presentar su solicitud completa de asilo. USCIS tiene 30 días para adjudicar la solicitud de EAD." }
      ]
    },
    vi: { 
      title: "Dịch Vụ Tị Nạn", 
      subtitle: "Bảo vệ cho những người chạy trốn bức hại", 
      sections: [
        { title: "Đơn Xin Tị Nạn", content: "Nếu bạn đối mặt với bức hại ở quốc gia của mình do chủng tộc, tôn giáo, quốc tịch, quan điểm chính trị hoặc thành viên của nhóm xã hội cụ thể, bạn có thể đủ điều kiện xin tị nạn. Tị nạn cung cấp bảo vệ và con đường đến thường trú." },
        {
          title: "Dịch Vụ Tị Nạn & Thuật Ngữ Chính",
          items: [
            "Tị Nạn: Bảo vệ được cấp cho công dân nước ngoài ở Mỹ không thể hoặc không muốn trở về nhà do bức hại hoặc sợ hãi có căn cứ",
            "Sợ Hãi Có Căn Cứ: Sợ hãi chủ quan chân thành và khách quan hợp lý về bức hại dựa trên bằng chứng đáng tin cậy",
            "Hạn Chót Một Năm: Đơn xin tị nạn phải được nộp trong vòng một năm kể từ khi đến trừ khi có hoàn cảnh đặc biệt",
            "Tị Nạn Khẳng Định: Đơn nộp với USCIS bởi người không trong thủ tục di dời",
            "Tị Nạn Phòng Thủ: Đơn nộp với tòa án di trú như phòng thủ chống di dời",
            "Mẫu I-589: Đơn Xin Tị Nạn và Hoãn Di Dời"
          ]
        }
      ],
      faq: [
        { question: "Sự khác biệt giữa tị nạn và tình trạng người tị nạn là gì?", answer: "Cả hai đều cung cấp bảo vệ khỏi bức hại, nhưng người tị nạn nộp đơn từ bên ngoài Mỹ trước khi đến, trong khi người xin tị nạn nộp đơn sau khi đến Mỹ hoặc tại cửa khẩu." },
        { question: "Tôi có thể làm việc trong khi đơn xin tị nạn đang chờ xử lý không?", answer: "Bạn có thể nộp đơn xin Giấy Phép Làm Việc (EAD) 150 ngày sau khi nộp đơn xin tị nạn đầy đủ. USCIS có 30 ngày để phán quyết đơn EAD." }
      ]
    }
  },
  citizenship: {
    en: { 
      title: "Citizenship & Naturalization", 
      subtitle: "Become a U.S. citizen through naturalization", 
      sections: [
        { 
          title: "Naturalization Process", 
          content: "If you've been a lawful permanent resident for at least 5 years (or 3 years if married to a U.S. citizen), you may be eligible to apply for citizenship. Citizenship provides voting rights, eligibility for federal jobs, and protection from deportation."
        },
        {
          title: "Citizenship & Naturalization Services & Key Terms",
          items: [
            "Naturalization: Legal process by which foreign national becomes U.S. citizen after meeting eligibility requirements",
            "Form N-400: Application for Naturalization, principal form filed by lawful permanent residents seeking citizenship",
            "Continuous Residence: Requirement to maintain continuous residence in U.S. for 5 years (or 3 years if married to U.S. citizen)",
            "Physical Presence: Must be physically present in U.S. for at least half the continuous residence period (30 or 18 months)",
            "Good Moral Character: Must demonstrate good moral character during statutory period, certain crimes create presumption of lack",
            "English Language Requirement: Applicants must demonstrate ability to read, write, speak, and understand basic English",
            "Civics Test: Must demonstrate knowledge of U.S. history and government by passing civics examination",
            "Oath of Allegiance: Final step where applicant takes oath renouncing foreign allegiances and pledging loyalty to U.S.",
            "Derivative Citizenship: Children automatically acquire citizenship through U.S. citizen parents under certain circumstances",
            "Certificate of Citizenship (N-600): Document proving U.S. citizenship acquired at birth abroad or through parents",
            "Three-Year Rule: LPRs married to U.S. citizen can naturalize after 3 years if still married and living together",
            "Military Naturalization: Special expedited naturalization provisions for current and former U.S. military service members",
            "Exemptions and Accommodations: Age and disability exemptions or accommodations for English and civics requirements",
            "Biometrics Appointment: Required fingerprinting and background check as part of naturalization process",
            "Dual Citizenship: U.S. allows dual citizenship, but some countries require renunciation of previous citizenship"
          ]
        }
      ],
      faq: [
        {
          question: "How long does naturalization take?",
          answer: "The naturalization process typically takes 8-12 months from filing Form N-400 to oath ceremony, though processing times vary by location and individual circumstances."
        },
        {
          question: "Can I travel while my naturalization application is pending?",
          answer: "Yes, you can travel on your green card while your N-400 is pending. However, extended absences may affect your continuous residence requirement and should be discussed with an attorney."
        }
      ]
    },
    es: { 
      title: "Ciudadanía y Naturalización", 
      subtitle: "Conviértase en ciudadano estadounidense mediante naturalización", 
      sections: [
        { 
          title: "Proceso de Naturalización", 
          content: "Si ha sido residente permanente legal durante al menos 5 años (o 3 años si está casado con un ciudadano estadounidense), puede ser elegible para solicitar la ciudadanía. La ciudadanía proporciona derechos de voto, elegibilidad para empleos federales y protección contra la deportación."
        },
        {
          title: "Servicios de Ciudadanía y Naturalización y Términos Clave",
          items: [
            "Naturalización: Proceso legal mediante el cual un nacional extranjero se convierte en ciudadano estadounidense después de cumplir con los requisitos de elegibilidad",
            "Formulario N-400: Solicitud de Naturalización, formulario principal presentado por residentes permanentes legales que buscan ciudadanía",
            "Residencia Continua: Requisito de mantener residencia continua en EE.UU. durante 5 años (o 3 años si está casado con ciudadano estadounidense)",
            "Presencia Física: Debe estar físicamente presente en EE.UU. durante al menos la mitad del período de residencia continua (30 o 18 meses)",
            "Buen Carácter Moral: Debe demostrar buen carácter moral durante el período estatutario, ciertos crímenes crean presunción de falta",
            "Requisito de Idioma Inglés: Los solicitantes deben demostrar habilidad para leer, escribir, hablar y entender inglés básico",
            "Examen Cívico: Debe demostrar conocimiento de la historia y gobierno de EE.UU. al aprobar el examen cívico",
            "Juramento de Lealtad: Paso final donde el solicitante presta juramento renunciando a lealtades extranjeras y prometiendo lealtad a EE.UU.",
            "Ciudadanía Derivada: Los niños adquieren automáticamente la ciudadanía a través de padres ciudadanos estadounidenses bajo ciertas circunstancias",
            "Certificado de Ciudadanía (N-600): Documento que prueba la ciudadanía estadounidense adquirida al nacer en el extranjero o a través de los padres",
            "Regla de Tres Años: Los LPR casados con ciudadano estadounidense pueden naturalizarse después de 3 años si aún están casados y viviendo juntos",
            "Naturalización Militar: Disposiciones especiales de naturalización acelerada para miembros actuales y anteriores del servicio militar de EE.UU.",
            "Exenciones y Acomodaciones: Exenciones o acomodaciones por edad y discapacidad para requisitos de inglés y cívica",
            "Cita de Biometría: Toma de huellas dactilares requerida y verificación de antecedentes como parte del proceso de naturalización",
            "Doble Ciudadanía: EE.UU. permite doble ciudadanía, pero algunos países requieren renunciar a la ciudadanía anterior"
          ]
        }
      ],
      faq: [
        {
          question: "¿Cuánto tiempo toma la naturalización?",
          answer: "El proceso de naturalización típicamente toma 8-12 meses desde la presentación del Formulario N-400 hasta la ceremonia de juramento, aunque los tiempos de procesamiento varían según la ubicación y las circunstancias individuales."
        },
        {
          question: "¿Puedo viajar mientras mi solicitud de naturalización está pendiente?",
          answer: "Sí, puede viajar con su tarjeta verde mientras su N-400 está pendiente. Sin embargo, las ausencias prolongadas pueden afectar su requisito de residencia continua y deben discutirse con un abogado."
        },
        {
          question: "¿Qué pasa si repruebo el examen de inglés o cívica?",
          answer: "Si reprueba cualquiera de los exámenes durante su entrevista, tendrá una segunda oportunidad de volver a tomar solo la parte que reprobó dentro de 60-90 días. USCIS proporciona materiales de estudio."
        },
        {
          question: "¿Puedo mantener mi ciudadanía original?",
          answer: "EE.UU. permite doble ciudadanía, pero debe verificar si su país de origen lo permite. Algunos países requieren que renuncie a su ciudadanía original al convertirse en ciudadano estadounidense."
        }
      ]
    },
    vi: { 
      title: "Quốc Tịch & Nhập Tịch", 
      subtitle: "Trở thành công dân Mỹ thông qua nhập tịch", 
      sections: [
        { 
          title: "Quy Trình Nhập Tịch", 
          content: "Nếu bạn đã là thường trú nhân hợp pháp trong ít nhất 5 năm (hoặc 3 năm nếu kết hôn với công dân Mỹ), bạn có thể đủ điều kiện nộp đơn xin quốc tịch. Quốc tịch cung cấp quyền bầu cử, đủ điều kiện cho công việc liên bang và bảo vệ khỏi truy xuất."
        },
        {
          title: "Dịch Vụ Quốc Tịch & Nhập Tịch và Thuật Ngữ Chính",
          items: [
            "Nhập Tịch: Quy trình pháp lý mà công dân nước ngoài trở thành công dân Mỹ sau khi đáp ứng yêu cầu đủ điều kiện",
            "Mẫu N-400: Đơn Xin Nhập Tịch, mẫu chính do thường trú nhân hợp pháp nộp để xin quốc tịch",
            "Cư Trú Liên Tục: Yêu cầu duy trì cư trú liên tục ở Mỹ trong 5 năm (hoặc 3 năm nếu kết hôn với công dân Mỹ)",
            "Hiện Diện Vật Lý: Phải có mặt vật lý ở Mỹ ít nhất một nửa thời gian cư trú liên tục (30 hoặc 18 tháng)",
            "Phẩm Chất Đạo Đức Tốt: Phải chứng minh phẩm chất đạo đức tốt trong thời kỳ theo luật định, một số tội phạm tạo giả định thiếu",
            "Yêu Cầu Tiếng Anh: Người nộp đơn phải chứng minh khả năng đọc, viết, nói và hiểu tiếng Anh cơ bản",
            "Bài Kiểm Tra Công Dân: Phải chứng minh kiến thức về lịch sử và chính phủ Mỹ bằng cách vượt qua kỳ thi công dân",
            "Lời Tuyên Thệ Trung Thành: Bước cuối cùng nơi người nộp đơn tuyên thệ từ bỏ lòng trung thành nước ngoài và cam kết trung thành với Mỹ",
            "Quốc Tịch Phái Sinh: Trẻ em tự động có được quốc tịch thông qua cha mẹ là công dân Mỹ trong một số trường hợp nhất định",
            "Giấy Chứng Nhận Quốc Tịch (N-600): Tài liệu chứng minh quốc tịch Mỹ có được khi sinh ở nước ngoài hoặc thông qua cha mẹ",
            "Quy Tắc Ba Năm: LPR kết hôn với công dán Mỹ có thể nhập tịch sau 3 năm nếu vẫn kết hôn và sống cùng nhau",
            "Nhập Tịch Quân Đội: Các điều khoản nhập tịch nhanh đặc biệt cho các thành viên quân đội Mỹ hiện tại và cựu chiến binh",
            "Miễn Trừ và Điều Chỉnh: Miễn trừ hoặc điều chỉnh về tuổi tác và khuyết tật cho yêu cầu tiếng Anh và công dân",
            "Cuộc Hẹn Sinh Trắc Học: Lấy dấu vân tay bắt buộc và kiểm tra lý lịch như một phần của quy trình nhập tịch",
            "Quốc Tịch Kép: Mỹ cho phép quốc tịch kép, nhưng một số quốc gia yêu cầu từ bỏ quốc tịch trước đó"
          ]
        }
      ],
      faq: [
        {
          question: "Nhập tịch mất bao lâu?",
          answer: "Quy trình nhập tịch thường mất 8-12 tháng từ khi nộp Mẫu N-400 đến lễ tuyên thệ, mặc dù thời gian xử lý khác nhau tùy theo địa điểm và hoàn cảnh cá nhân."
        },
        {
          question: "Tôi có thể đi du lịch trong khi đơn nhập tịch đang chờ xử lý không?",
          answer: "Có, bạn có thể đi du lịch bằng thẻ xanh của mình trong khi N-400 đang chờ xử lý. Tuy nhiên, vắng mặt kéo dài có thể ảnh hưởng đến yêu cầu cư trú liên tục của bạn và nên thảo luận với luật sư."
        },
        {
          question: "Nếu tôi trượt bài kiểm tra tiếng Anh hoặc công dân thì sao?",
          answer: "Nếu bạn trượt một trong hai bài kiểm tra trong cuộc phỏng vấn, bạn sẽ có cơ hội thứ hai để làm lại chỉ phần bạn trượt trong vòng 60-90 ngày. USCIS cung cấp tài liệu học tập."
        },
        {
          question: "Tôi có thể giữ quốc tịch ban đầu của mình không?",
          answer: "Mỹ cho phép quốc tịch kép, nhưng bạn nên kiểm tra xem quốc gia của bạn có cho phép không. Một số quốc gia yêu cầu bạn từ bỏ quốc tịch ban đầu khi trở thành công dân Mỹ."
        }
      ]
    }
  },
  consularProcessing: {
    en: { 
      title: "Consular Processing", 
      subtitle: "Immigrant visa processing abroad", 
      sections: [
        { 
          title: "Consular Processing Services", 
          content: "Once your immigrant petition is approved, you'll complete the visa process at a U.S. consulate in your home country. This involves document submission, medical examination, and a consular interview before receiving your immigrant visa."
        },
        {
          title: "Consular Processing Services & Key Terms",
          items: [
            "Consular Processing: Method of obtaining immigrant visa through U.S. consulate abroad rather than adjusting status within U.S.",
            "National Visa Center (NVC): Department of State facility processing approved immigrant petitions before scheduling consular interviews",
            "Form DS-260: Online Immigrant Visa Application completed by intending immigrants for consular processing",
            "Civil Documents: Required documents including birth certificates, marriage certificates, divorce decrees, police certificates, and military records",
            "Affidavit of Support (I-864): Legally enforceable contract where sponsor accepts financial responsibility for immigrant",
            "Joint Sponsor: Additional sponsor meeting income requirements if primary sponsor's income insufficient",
            "Medical Examination: Required exam by panel physician approved by consulate, must meet vaccination requirements",
            "Police Certificates: Criminal background checks from each country where applicant lived 6+ months since age 16",
            "Consular Interview: In-person interview at U.S. embassy/consulate where consular officer determines visa eligibility",
            "Administrative Processing: Additional background checks or document review after interview, common with certain countries or cases",
            "221(g) Refusal: Temporary refusal pending additional information or administrative processing",
            "Visa Packet: Sealed envelope containing approved visa and supporting documents, must not be opened by applicant",
            "Port of Entry: Upon arrival in U.S., immigrant visa holder inspected by CBP and admitted as permanent resident",
            "Green Card Delivery: Physical green card mailed to U.S. address within weeks after admission",
            "Two-Year Conditional Residence: Applies if marriage less than two years old when permanent residence granted"
          ]
        }
      ],
      faq: [
        {
          question: "How long does consular processing take?",
          answer: "After petition approval, consular processing typically takes 6-12 months, depending on the NVC processing time, consular post scheduling, and any additional administrative processing required."
        },
        {
          question: "What happens if I'm refused a visa at the consulate?",
          answer: "Visa refusals can be temporary (221(g) requiring additional documents) or permanent (inadmissibility grounds). Depending on the reason, you may need to provide additional evidence, apply for a waiver, or reconsider your eligibility."
        }
      ]
    },
    es: { 
      title: "Procesamiento Consular", 
      subtitle: "Procesamiento de visa de inmigrante en el extranjero", 
      sections: [
        { 
          title: "Servicios de Procesamiento Consular", 
          content: "Una vez que su petición de inmigrante sea aprobada, completará el proceso de visa en un consulado de EE.UU. en su país de origen. Esto implica presentación de documentos, examen médico y una entrevista consular antes de recibir su visa de inmigrante."
        },
        {
          title: "Servicios de Procesamiento Consular y Términos Clave",
          items: [
            "Procesamiento Consular: Método de obtención de visa de inmigrante a través del consulado de EE.UU. en el extranjero en lugar de ajustar estatus dentro de EE.UU.",
            "Centro Nacional de Visas (NVC): Instalación del Departamento de Estado que procesa peticiones de inmigrante aprobadas antes de programar entrevistas consulares",
            "Formulario DS-260: Solicitud de Visa de Inmigrante en línea completada por inmigrantes que tienen intención para procesamiento consular",
            "Documentos Civiles: Documentos requeridos incluyendo certificados de nacimiento, certificados de matrimonio, decretos de divorcio, certificados de policía y registros militares",
            "Declaración Jurada de Apoyo (I-864): Contrato legalmente ejecutable donde el patrocinador acepta responsabilidad financiera por el inmigrante",
            "Co-patrocinador: Patrocinador adicional que cumple con requisitos de ingresos si el ingreso del patrocinador principal es insuficiente",
            "Examen Médico: Examen requerido por médico del panel aprobado por el consulado, debe cumplir con requisitos de vacunación",
            "Certificados de Policía: Verificaciones de antecedentes penales de cada país donde el solicitante vivió 6+ meses desde los 16 años",
            "Entrevista Consular: Entrevista en persona en embajada/consulado de EE.UU. donde el oficial consular determina elegibilidad para visa",
            "Procesamiento Administrativo: Verificaciones adicionales de antecedentes o revisión de documentos después de la entrevista, común con ciertos países o casos",
            "Rechazo 221(g): Rechazo temporal pendiente de información adicional o procesamiento administrativo",
            "Paquete de Visa: Sobre sellado que contiene visa aprobada y documentos de respaldo, no debe ser abierto por el solicitante",
            "Puerto de Entrada: Al llegar a EE.UU., el titular de visa de inmigrante es inspeccionado por CBP y admitido como residente permanente",
            "Entrega de Tarjeta Verde: Tarjeta verde física enviada por correo a dirección de EE.UU. dentro de semanas después de la admisión",
            "Residencia Condicional de Dos Años: Se aplica si el matrimonio tiene menos de dos años al momento de otorgar la residencia permanente"
          ]
        }
      ],
      faq: [
        {
          question: "¿Cuánto tiempo toma el procesamiento consular?",
          answer: "Después de la aprobación de la petición, el procesamiento consular típicamente toma 6-12 meses, dependiendo del tiempo de procesamiento del NVC, programación del puesto consular y cualquier procesamiento administrativo adicional requerido."
        },
        {
          question: "¿Qué pasa si me niegan la visa en el consulado?",
          answer: "Los rechazos de visa pueden ser temporales (221(g) requiriendo documentos adicionales) o permanentes (motivos de inadmisibilidad). Dependiendo de la razón, puede necesitar proporcionar evidencia adicional, solicitar una exención o reconsiderar su elegibilidad."
        },
        {
          question: "¿Qué sucede en la entrevista consular?",
          answer: "Un oficial consular revisará su solicitud, verificará sus documentos, hará preguntas sobre su relación (para casos basados en familia) o empleo (para casos basados en empleo), y determinará la elegibilidad de visa."
        }
      ]
    },
    vi: { 
      title: "Xử Lý Lãnh Sự", 
      subtitle: "Xử lý visa nhập cư ở nước ngoài", 
      sections: [
        { 
          title: "Dịch Vụ Xử Lý Lãnh Sự", 
          content: "Khi đơn nhập cư của bạn được chấp thuận, bạn sẽ hoàn thành quy trình visa tại lãnh sự quán Mỹ ở quốc gia của bạn. Điều này bao gồm nộp tài liệu, khám sức khỏe và phỏng vấn lãnh sự trước khi nhận visa nhập cư của bạn."
        },
        {
          title: "Dịch Vụ Xử Lý Lãnh Sự & Thuật Ngữ Chính",
          items: [
            "Xử Lý Lãnh Sự: Phương pháp lấy visa nhập cư thông qua lãnh sự quán Mỹ ở nước ngoài thay vì điều chỉnh tình trạng trong Mỹ",
            "Trung Tâm Visa Quốc Gia (NVC): Cơ sở của Bộ Ngoại giao xử lý đơn nhập cư đã được phê duyệt trước khi lên lịch phỏng vấn lãnh sự",
            "Mẫu DS-260: Đơn Xin Visa Nhập Cư Trực Tuyến do người nhập cư dự định hoàn thành để xử lý lãnh sự",
            "Giấy Tờ Dân Sự: Các tài liệu bắt buộc bao gồm giấy khai sinh, giấy chứng nhận kết hôn, lệnh ly hôn, giấy chứng nhận cảnh sát và hồ sơ quân sự",
            "Tờ Khai Hỗ Trợ (I-864): Hợp đồng có thể thi hành theo pháp luật nơi người bảo lãnh chấp nhận trách nhiệm tài chính cho người nhập cư",
            "Người Bảo Lãnh Chung: Người bảo lãnh bổ sung đáp ứng yêu cầu thu nhập nếu thu nhập của người bảo lãnh chính không đủ",
            "Khám Sức Khỏe: Khám bắt buộc bởi bác sĩ hội đồng được lãnh sự quán phê duyệt, phải đáp ứng yêu cầu tiêm chủng",
            "Giấy Chứng Nhận Cảnh Sát: Kiểm tra lý lịch tội phạm từ mỗi quốc gia nơi người nộp đơn sống 6+ tháng kể từ 16 tuổi",
            "Phỏng Vấn Lãnh Sự: Phỏng vấn trực tiếp tại đại sứ quán/lãnh sự quán Mỹ nơi viên chức lãnh sự xác định đủ điều kiện visa",
            "Xử Lý Hành Chính: Kiểm tra lý lịch bổ sung hoặc xem xét tài liệu sau phỏng vấn, phổ biến với một số quốc gia hoặc trường hợp",
            "Từ Chối 221(g): Từ chối tạm thời chờ thông tin bổ sung hoặc xử lý hành chính",
            "Gói Visa: Phong bì niêm phong chứa visa đã được phê duyệt và tài liệu hỗ trợ, không được người nộp đơn mở",
            "Cửa Khẩu Nhập Cảnh: Khi đến Mỹ, người có visa nhập cư được CBP kiểm tra và cho phép nhập cảnh với tư cách thường trú nhân",
            "Giao Thẻ Xanh: Thẻ xanh vật lý được gửi qua thư đến địa chỉ Mỹ trong vòng vài tuần sau khi nhập cảnh",
            "Thường Trú Có Điều Kiện Hai Năm: Áp dụng nếu cuộc hôn nhân dưới hai năm khi được cấp thường trú"
          ]
        }
      ],
      faq: [
        {
          question: "Xử lý lãnh sự mất bao lâu?",
          answer: "Sau khi đơn được phê duyệt, xử lý lãnh sự thường mất 6-12 tháng, tùy thuộc vào thời gian xử lý của NVC, lịch trình của cơ quan lãnh sự và bất kỳ xử lý hành chính bổ sung nào được yêu cầu."
        },
        {
          question: "Điều gì xảy ra nếu tôi bị từ chối visa tại lãnh sự quán?",
          answer: "Từ chối visa có thể là tạm thời (221(g) yêu cầu tài liệu bổ sung) hoặc vĩnh viễn (lý do không được nhập cảnh). Tùy thuộc vào lý do, bạn có thể cần cung cấp bằng chứng bổ sung, nộp đơn xin miễn trừ hoặc xem xét lại đủ điều kiện của bạn."
        },
        {
          question: "Điều gì xảy ra tại cuộc phỏng vấn lãnh sự?",
          answer: "Một viên chức lãnh sự sẽ xem xét đơn của bạn, xác minh tài liệu của bạn, đặt câu hỏi về mối quan hệ của bạn (đối với các trường hợp dựa trên gia đình) hoặc việc làm (đối với các trường hợp dựa trên việc làm), và xác định đủ điều kiện visa."
        }
      ]
    }
  },
  greenCardRenewal: {
    en: { 
      title: "Green Card Renewal", 
      subtitle: "Renew or replace your permanent resident card", 
      sections: [
        { 
          title: "Green Card Renewal Services", 
          content: "Green cards must be renewed every 10 years. Don't wait until it expires - apply for renewal 6 months before expiration. An expired card does not affect your permanent resident status, but you need a valid card for employment verification and travel."
        },
        {
          title: "Green Card Renewal Services & Key Terms",
          items: [
            "Form I-90: Application to Replace Permanent Resident Card for renewal, replacement, or update",
            "Permanent Resident Card: Green card valid for 10 years for unconditional residents, 2 years for conditional residents",
            "Card Renewal: Process to obtain new 10-year green card before or after current card expires",
            "Card Replacement: Obtaining new card if lost, stolen, destroyed, or contains incorrect information",
            "Conditional Green Card: Two-year card issued when marriage less than two years old, requires Form I-751 to remove conditions",
            "Form I-751: Petition to Remove Conditions on Residence filed 90 days before 2-year anniversary of conditional residence",
            "Biometrics Appointment: Required fingerprinting and photo for background check and card production",
            "Fee Waiver: Low-income applicants may qualify for waiver of I-90 filing fee by filing Form I-912",
            "Automatic Extension: Receipt notice extends expired green card validity for 24 months for employment and travel",
            "Commuter Green Card: Permanent residents living abroad but commuting to U.S. for work, may face scrutiny for abandonment",
            "Reentry Permit: Document allowing LPR to remain abroad for up to 2 years without abandoning residence",
            "Abandonment of Residence: Extended absences from U.S. or actions may result in loss of permanent resident status",
            "SB-1 Returning Resident Visa: For LPRs abroad over 1 year unable to return within travel document validity",
            "USCIS Online Account: Electronic filing and case management system for Form I-90 and other applications",
            "10-Year Residency: Permanent residents maintain status indefinitely unless abandoned or removed, but card requires periodic renewal"
          ]
        }
      ],
      faq: [
        {
          question: "Can I travel with an expired green card?",
          answer: "It's not recommended. While your permanent resident status doesn't expire, airlines may not board you and CBP may question your status. Apply for renewal 6 months before expiration and carry your receipt notice when traveling."
        },
        {
          question: "How long does green card renewal take?",
          answer: "Form I-90 processing typically takes 8-12 months. You'll receive a receipt notice extending your expired card's validity by 24 months for employment verification and travel purposes."
        }
      ]
    },
    es: { 
      title: "Renovación de Tarjeta Verde", 
      subtitle: "Renueve o reemplace su tarjeta de residente permanente", 
      sections: [
        { 
          title: "Servicios de Renovación de Tarjeta Verde", 
          content: "Las tarjetas verdes deben renovarse cada 10 años. No espere hasta que expire: solicite la renovación 6 meses antes del vencimiento. Una tarjeta vencida no afecta su estatus de residente permanente, pero necesita una tarjeta válida para verificación de empleo y viajes."
        },
        {
          title: "Servicios de Renovación de Tarjeta Verde y Términos Clave",
          items: [
            "Formulario I-90: Solicitud para Reemplazar Tarjeta de Residente Permanente para renovación, reemplazo o actualización",
            "Tarjeta de Residente Permanente: Tarjeta verde válida por 10 años para residentes incondicionales, 2 años para residentes condicionales",
            "Renovación de Tarjeta: Proceso para obtener nueva tarjeta verde de 10 años antes o después de que la tarjeta actual expire",
            "Reemplazo de Tarjeta: Obtención de nueva tarjeta si se pierde, es robada, destruida o contiene información incorrecta",
            "Tarjeta Verde Condicional: Tarjeta de dos años emitida cuando el matrimonio tiene menos de dos años, requiere Formulario I-751 para remover condiciones",
            "Formulario I-751: Petición para Remover Condiciones de Residencia presentada 90 días antes del segundo aniversario de residencia condicional",
            "Cita de Biometría: Toma de huellas dactilares y foto requeridas para verificación de antecedentes y producción de tarjeta",
            "Exención de Tarifa: Solicitantes de bajos ingresos pueden calificar para exención de la tarifa de presentación I-90 mediante presentación del Formulario I-912",
            "Extensión Automática: El aviso de recibo extiende la validez de la tarjeta verde vencida por 24 meses para empleo y viajes",
            "Tarjeta Verde de Viajero Frecuente: Residentes permanentes que viven en el extranjero pero viajan a EE.UU. para trabajar, pueden enfrentar escrutinio por abandono",
            "Permiso de Reingreso: Documento que permite a LPR permanecer en el extranjero hasta 2 años sin abandonar la residencia",
            "Abandono de Residencia: Ausencias prolongadas de EE.UU. o acciones pueden resultar en pérdida del estatus de residente permanente",
            "Visa SB-1 de Residente que Regresa: Para LPR en el extranjero por más de 1 año que no pueden regresar dentro de la validez del documento de viaje",
            "Cuenta en Línea de USCIS: Sistema de presentación electrónica y gestión de casos para Formulario I-90 y otras solicitudes",
            "Residencia de 10 Años: Los residentes permanentes mantienen el estatus indefinidamente a menos que sea abandonado o removido, pero la tarjeta requiere renovación periódica"
          ]
        }
      ],
      faq: [
        {
          question: "¿Puedo viajar con una tarjeta verde vencida?",
          answer: "No es recomendable. Aunque su estatus de residente permanente no vence, las aerolíneas pueden no permitirle abordar y CBP puede cuestionar su estatus. Solicite la renovación 6 meses antes del vencimiento y lleve su aviso de recibo cuando viaje."
        },
        {
          question: "¿Cuánto tiempo toma la renovación de la tarjeta verde?",
          answer: "El procesamiento del Formulario I-90 típicamente toma 8-12 meses. Recibirá un aviso de recibo que extiende la validez de su tarjeta vencida por 24 meses para propósitos de verificación de empleo y viajes."
        },
        {
          question: "¿Qué pasa si pierdo mi tarjeta verde?",
          answer: "Debe presentar el Formulario I-90 inmediatamente para reemplazar su tarjeta perdida o robada. Si necesita viajar antes de recibir la tarjeta de reemplazo, puede solicitar un sello temporal de I-551 en su pasaporte en una oficina local de USCIS."
        }
      ]
    },
    vi: { 
      title: "Gia Hạn Thẻ Xanh", 
      subtitle: "Gia hạn hoặc thay thế thẻ thường trú nhân", 
      sections: [
        { 
          title: "Dịch Vụ Gia Hạn Thẻ Xanh", 
          content: "Thẻ xanh phải được gia hạn mỗi 10 năm. Đừng đợi đến khi hết hạn - nộp đơn gia hạn 6 tháng trước khi hết hạn. Thẻ hết hạn không ảnh hưởng đến tình trạng thường trú nhân của bạn, nhưng bạn cần thẻ hợp lệ để xác minh việc làm và đi du lịch."
        },
        {
          title: "Dịch Vụ Gia Hạn Thẻ Xanh & Thuật Ngữ Chính",
          items: [
            "Mẫu I-90: Đơn Xin Thay Thế Thẻ Thường Trú Nhân để gia hạn, thay thế hoặc cập nhật",
            "Thẻ Thường Trú Nhân: Thẻ xanh có hiệu lực 10 năm cho thường trú nhân vô điều kiện, 2 năm cho thường trú nhân có điều kiện",
            "Gia Hạn Thẻ: Quy trình để có được thẻ xanh 10 năm mới trước hoặc sau khi thẻ hiện tại hết hạn",
            "Thay Thế Thẻ: Lấy thẻ mới nếu bị mất, bị đánh cắp, bị hủy hoại hoặc chứa thông tin không chính xác",
            "Thẻ Xanh Có Điều Kiện: Thẻ hai năm được cấp khi cuộc hôn nhân dưới hai năm, yêu cầu Mẫu I-751 để loại bỏ điều kiện",
            "Mẫu I-751: Đơn Xin Loại Bỏ Điều Kiện Cư Trú nộp 90 ngày trước kỷ niệm hai năm của cư trú có điều kiện",
            "Cuộc Hẹn Sinh Trắc Học: Lấy dấu vân tay và ảnh bắt buộc để kiểm tra lý lịch và sản xuất thẻ",
            "Miễn Phí: Người nộp đơn có thu nhập thấp có thể đủ điều kiện miễn phí nộp đơn I-90 bằng cách nộp Mẫu I-912",
            "Gia Hạn Tự Động: Thông báo biên nhận kéo dài hiệu lực thẻ xanh hết hạn thêm 24 tháng cho việc làm và đi du lịch",
            "Thẻ Xanh Người Đi Làm: Thường trú nhân sống ở nước ngoài nhưng đi làm ở Mỹ, có thể phải đối mặt với sự giám sát về từ bỏ",
            "Giấy Phép Nhập Cảnh Lại: Tài liệu cho phép LPR ở lại nước ngoài tối đa 2 năm mà không từ bỏ cư trú",
            "Từ Bỏ Cư Trú: Vắng mặt kéo dài khỏi Mỹ hoặc hành động có thể dẫn đến mất tình trạng thường trú nhân",
            "Visa SB-1 Người Cư Trú Trở Lại: Dành cho LPR ở nước ngoài hơn 1 năm không thể quay lại trong thời hạn hiệu lực của tài liệu đi lại",
            "Tài Khoản Trực Tuyến USCIS: Hệ thống nộp đơn điện tử và quản lý hồ sơ cho Mẫu I-90 và các đơn khác",
            "Cư Trú 10 Năm: Thường trú nhân duy trì tình trạng vô thời hạn trừ khi bị từ bỏ hoặc di dời, nhưng thẻ yêu cầu gia hạn định kỳ"
          ]
        }
      ],
      faq: [
        {
          question: "Tôi có thể đi du lịch với thẻ xanh hết hạn không?",
          answer: "Không được khuyến nghị. Mặc dù tình trạng thường trú nhân của bạn không hết hạn, hãng hàng không có thể không cho bạn lên máy bay và CBP có thể đặt câu hỏi về tình trạng của bạn. Nộp đơn gia hạn 6 tháng trước khi hết hạn và mang theo thông báo biên nhận khi đi du lịch."
        },
        {
          question: "Gia hạn thẻ xanh mất bao lâu?",
          answer: "Xử lý Mẫu I-90 thường mất 8-12 tháng. Bạn sẽ nhận được thông báo biên nhận kéo dài hiệu lực thẻ hết hạn của bạn thêm 24 tháng cho mục đích xác minh việc làm và đi du lịch."
        },
        {
          question: "Điều gì xảy ra nếu tôi làm mất thẻ xanh?",
          answer: "Bạn phải nộp Mẫu I-90 ngay lập tức để thay thế thẻ bị mất hoặc bị đánh cắp. Nếu bạn cần đi du lịch trước khi nhận thẻ thay thế, bạn có thể yêu cầu con dấu I-551 tạm thời trong hộ chiếu của bạn tại văn phòng USCIS địa phương."
        }
      ]
    }
  },
  uvisa: {
    en: { 
      title: "U Visa for Crime Victims", 
      subtitle: "Immigration relief for crime victims who assist law enforcement", 
      sections: [
        { 
          title: "U Visa Services", 
          content: "If you've been a victim of qualifying crime and helped law enforcement, you may be eligible for a U visa. This provides temporary immigration status, work authorization, and a pathway to permanent residence for crime victims who assist authorities."
        },
        {
          title: "U Visa Services & Key Terms",
          items: [
            "U Nonimmigrant Status: Temporary immigration status for victims of qualifying crimes who assist law enforcement",
            "Form I-918: Petition for U Nonimmigrant Status filed by crime victim with law enforcement certification",
            "Qualifying Criminal Activity: Includes domestic violence, sexual assault, trafficking, kidnapping, extortion, and 20+ other crimes",
            "Law Enforcement Certification (Form I-918B): Certification by law enforcement that petitioner was helpful in investigation/prosecution",
            "Substantial Physical or Mental Abuse: Victim must have suffered substantial abuse as result of qualifying criminal activity",
            "Helpfulness Requirement: Must have been, be, or be likely to be helpful to law enforcement in investigation or prosecution",
            "Annual Cap: 10,000 U visas available per fiscal year for principal petitioners, derivatives not subject to cap",
            "U Visa Waitlist: When cap reached, qualifying petitioners placed on waiting list and may receive deferred action",
            "Derivative Beneficiaries: Qualifying family members including spouse, children, parents (if under 21), and siblings (if under 21)",
            "Bona Fide Determination: Preliminary review providing work authorization and deferred action while awaiting visa availability",
            "Four-Year Validity: U visa valid for 4 years, may be extended in certain circumstances",
            "Continuous Physical Presence: After 3 years in U status, may apply for permanent residence if maintained continuous presence",
            "Form I-929: Petition for Qualifying Family Member of U-1 Nonimmigrant to obtain derivative U status",
            "Waiver of Inadmissibility: U visa applicants may apply for waivers of most grounds of inadmissibility",
            "Path to Green Card: U visa holders may adjust to permanent residence after 3 years if requirements met"
          ]
        }
      ],
      faq: [
        {
          question: "How long does the U visa process take?",
          answer: "Due to the annual cap of 10,000 visas, current processing times are 5-7 years. However, approved petitioners receive work authorization and deferred action while waiting for visa availability."
        },
        {
          question: "Can my family members get U visas too?",
          answer: "Yes, qualifying family members may be included as derivatives. If you're under 21, your parents and siblings under 21 can be included. If over 21, your spouse and children under 21 can be included."
        }
      ]
    },
    es: { 
      title: "Visa U para Víctimas de Crimen", 
      subtitle: "Alivio migratorio para víctimas de crimen que ayudan a las autoridades", 
      sections: [
        { 
          title: "Servicios de Visa U", 
          content: "Si ha sido víctima de un crimen calificado y ayudó a las autoridades, puede ser elegible para una visa U. Esto proporciona estatus migratorio temporal, autorización de trabajo y un camino hacia la residencia permanente para víctimas de crimen que ayudan a las autoridades."
        },
        {
          title: "Servicios de Visa U y Términos Clave",
          items: [
            "Estatus de No Inmigrante U: Estatus migratorio temporal para víctimas de crímenes calificados que ayudan a las autoridades",
            "Formulario I-918: Petición para Estatus de No Inmigrante U presentada por víctima de crimen con certificación de las autoridades",
            "Actividad Criminal Calificada: Incluye violencia doméstica, asalto sexual, tráfico, secuestro, extorsión y más de 20 otros crímenes",
            "Certificación de las Autoridades (Formulario I-918B): Certificación por las autoridades de que el peticionario fue útil en la investigación/procesamiento",
            "Abuso Físico o Mental Sustancial: La víctima debe haber sufrido abuso sustancial como resultado de la actividad criminal calificada",
            "Requisito de Ayuda: Debe haber sido, ser o es probable que sea útil para las autoridades en la investigación o procesamiento",
            "Límite Anual: 10,000 visas U disponibles por año fiscal para peticionarios principales, derivados no sujetos al límite",
            "Lista de Espera de Visa U: Cuando se alcanza el límite, peticionarios calificados se colocan en lista de espera y pueden recibir acción diferida",
            "Beneficiarios Derivados: Miembros de familia calificados incluyendo cónyuge, hijos, padres (si menor de 21) y hermanos (si menor de 21)",
            "Determinación de Buena Fe: Revisión preliminar que proporciona autorización de trabajo y acción diferida mientras espera disponibilidad de visa",
            "Validez de Cuatro Años: Visa U válida por 4 años, puede extenderse en ciertas circunstancias",
            "Presencia Física Continua: Después de 3 años en estatus U, puede solicitar residencia permanente si mantuvo presencia continua",
            "Formulario I-929: Petición para Miembro de Familia Calificado de No Inmigrante U-1 para obtener estatus U derivado",
            "Exención de Inadmisibilidad: Solicitantes de visa U pueden solicitar exenciones de la mayoría de motivos de inadmisibilidad",
            "Camino hacia la Tarjeta Verde: Titulares de visa U pueden ajustar a residencia permanente después de 3 años si cumplen requisitos"
          ]
        }
      ],
      faq: [
        {
          question: "¿Cuánto tiempo toma el proceso de visa U?",
          answer: "Debido al límite anual de 10,000 visas, los tiempos de procesamiento actuales son de 5-7 años. Sin embargo, los peticionarios aprobados reciben autorización de trabajo y acción diferida mientras esperan la disponibilidad de visa."
        },
        {
          question: "¿Pueden mis familiares obtener visas U también?",
          answer: "Sí, miembros de familia calificados pueden ser incluidos como derivados. Si es menor de 21, sus padres y hermanos menores de 21 pueden ser incluidos. Si es mayor de 21, su cónyuge e hijos menores de 21 pueden ser incluidos."
        },
        {
          question: "¿Qué crímenes califican para la visa U?",
          answer: "Los crímenes calificados incluyen violencia doméstica, asalto sexual, tráfico humano, secuestro, acoso, chantaje, manipulación de testigos y otros crímenes graves. El crimen debe haber ocurrido en EE.UU. y debe haber sufrido abuso físico o mental sustancial."
        }
      ]
    },
    vi: { 
      title: "Visa U cho Nạn Nhân Tội Phạm", 
      subtitle: "Cứu trợ di trú cho nạn nhân tội phạm hỗ trợ cơ quan thực thi pháp luật", 
      sections: [
        { 
          title: "Dịch Vụ Visa U", 
          content: "Nếu bạn là nạn nhân của tội phạm đủ điều kiện và giúp cơ quan thực thi pháp luật, bạn có thể đủ điều kiện xin visa U. Điều này cung cấp tình trạng di trú tạm thời, giấy phép làm việc và con đường đến thường trú cho nạn nhân tội phạm hỗ trợ cơ quan chức năng."
        },
        {
          title: "Dịch Vụ Visa U & Thuật Ngữ Chính",
          items: [
            "Tình Trạng Không Nhập Cư U: Tình trạng di trú tạm thời cho nạn nhân của tội phạm đủ điều kiện hỗ trợ cơ quan thực thi pháp luật",
            "Mẫu I-918: Đơn Xin Tình Trạng Không Nhập Cư U do nạn nhân tội phạm nộp với chứng nhận của cơ quan thực thi pháp luật",
            "Hoạt Động Tội Phạm Đủ Điều Kiện: Bao gồm bạo lực gia đình, tấn công tình dục, buôn người, bắt cóc, tống tiền và hơn 20 tội phạm khác",
            "Chứng Nhận Cơ Quan Thực Thi Pháp Luật (Mẫu I-918B): Chứng nhận của cơ quan thực thi pháp luật rằng người đệ đơn hữu ích trong điều tra/truy tố",
            "Lạm Dụng Thể Chất hoặc Tinh Thần Đáng Kể: Nạn nhân phải chịu lạm dụng đáng kể do hoạt động tội phạm đủ điều kiện",
            "Yêu Cầu Hữu Ích: Phải đã, đang hoặc có khả năng hữu ích cho cơ quan thực thi pháp luật trong điều tra hoặc truy tố",
            "Hạn Mức Hàng Năm: 10,000 visa U có sẵn mỗi năm tài chính cho người đệ đơn chính, người phái sinh không thuộc hạn mức",
            "Danh Sách Chờ Visa U: Khi đạt hạn mức, người đệ đơn đủ điều kiện được đặt vào danh sách chờ và có thể nhận hành động hoãn lại",
            "Người Thụ Hưởng Phái Sinh: Thành viên gia đình đủ điều kiện bao gồm vợ/chồng, con cái, cha mẹ (nếu dưới 21) và anh chị em (nếu dưới 21)",
            "Xác Định Thiện Chí: Xem xét sơ bộ cung cấp giấy phép làm việc và hành động hoãn lại trong khi chờ visa có sẵn",
            "Hiệu Lực Bốn Năm: Visa U có hiệu lực 4 năm, có thể được gia hạn trong một số trường hợp nhất định",
            "Hiện Diện Vật Lý Liên Tục: Sau 3 năm ở tình trạng U, có thể nộp đơn xin thường trú nếu duy trì sự hiện diện liên tục",
            "Mẫu I-929: Đơn Xin Cho Thành Viên Gia Đình Đủ Điều Kiện của Người Không Nhập Cư U-1 để có được tình trạng U phái sinh",
            "Miễn Trừ Không Được Nhập Cảnh: Người nộp đơn visa U có thể nộp đơn xin miễn trừ hầu hết các lý do không được nhập cảnh",
            "Con Đường Đến Thẻ Xanh: Người có visa U có thể điều chỉnh sang thường trú sau 3 năm nếu đáp ứng yêu cầu"
          ]
        }
      ],
      faq: [
        {
          question: "Quy trình visa U mất bao lâu?",
          answer: "Do hạn mức hàng năm là 10,000 visa, thời gian xử lý hiện tại là 5-7 năm. Tuy nhiên, người đệ đơn được phê duyệt nhận giấy phép làm việc và hành động hoãn lại trong khi chờ visa có sẵn."
        },
        {
          question: "Các thành viên gia đình của tôi có thể nhận visa U không?",
          answer: "Có, các thành viên gia đình đủ điều kiện có thể được bao gồm như người phái sinh. Nếu bạn dưới 21 tuổi, cha mẹ và anh chị em dưới 21 tuổi của bạn có thể được bao gồm. Nếu trên 21 tuổi, vợ/chồng và con dưới 21 tuổi của bạn có thể được bao gồm."
        },
        {
          question: "Những tội phạm nào đủ điều kiện cho visa U?",
          answer: "Tội phạm đủ điều kiện bao gồm bạo lực gia đình, tấn công tình dục, buôn người, bắt cóc, theo dõi, tống tiền, can thiệp nhân chứng và các tội phạm nghiêm trọng khác. Tội phạm phải xảy ra ở Mỹ và bạn phải chịu lạm dụng thể chất hoặc tinh thần đáng kể."
        }
      ]
    }
  },
  vawa: {
    en: { 
      title: "VAWA Petitions", 
      subtitle: "Self-petition for abused spouses and children", 
      sections: [
        { 
          title: "VAWA Services", 
          content: "The Violence Against Women Act allows victims of domestic violence to self-petition for immigration status without their abuser's knowledge. VAWA protections are available to both women and men who are victims of abuse by U.S. citizen or permanent resident spouses or parents."
        },
        {
          title: "VAWA Services & Key Terms",
          items: [
            "Violence Against Women Act (VAWA): Federal law allowing abused spouses, children, and parents to self-petition for immigration status",
            "Form I-360: Petition for Amerasian, Widow(er), or Special Immigrant used for VAWA self-petitions",
            "Self-Petition: Allows victim to petition for permanent residence independently without abuser's knowledge or cooperation",
            "Battery or Extreme Cruelty: Physical violence, sexual abuse, or extreme psychological abuse constituting qualifying abuse",
            "Qualifying Relationship: Must be spouse, child, or parent of U.S. citizen or lawful permanent resident abuser",
            "Good Moral Character: VAWA petitioner must demonstrate good moral character during 3 years before filing",
            "Good Faith Marriage: For spouse petitioners, must show marriage entered in good faith, not solely for immigration benefits",
            "Residence Requirement: Must have resided with abuser at some point during relationship",
            "Prima Facie Determination: Initial USCIS finding that petition approvable, triggers eligibility for certain public benefits",
            "Confidentiality Protections: USCIS prohibited from disclosing information about VAWA petition to abuser",
            "Derivative Beneficiaries: Children under 21 may be included in parent's VAWA petition or file own petition",
            "Cancellation of Removal: Special immigration court relief for VAWA petitioners in removal proceedings",
            "Work Authorization: VAWA petitioners may apply for employment authorization while petition pending",
            "Adjustment of Status: After VAWA approval, can apply for green card through Form I-485",
            "Public Benefits Eligibility: Prima facie VAWA petitioners eligible for certain federal and state benefits"
          ]
        }
      ],
      faq: [
        {
          question: "Will my abuser know I filed a VAWA petition?",
          answer: "No. USCIS maintains strict confidentiality and is prohibited by law from disclosing any information about your VAWA petition to your abuser. Your petition is processed independently."
        },
        {
          question: "Can men file VAWA petitions?",
          answer: "Yes, despite the name, VAWA protections are available to all victims of domestic violence regardless of gender. Male victims of abuse by U.S. citizen or permanent resident spouses or parents can file VAWA self-petitions."
        }
      ]
    },
    es: { 
      title: "Peticiones VAWA", 
      subtitle: "Auto-petición para cónyuges e hijos maltratados", 
      sections: [
        { 
          title: "Servicios VAWA", 
          content: "La Ley de Violencia Contra las Mujeres permite a las víctimas de violencia doméstica auto-peticionar estatus migratorio sin el conocimiento de su agresor. Las protecciones VAWA están disponibles tanto para mujeres como para hombres que son víctimas de abuso por parte de cónyuges o padres ciudadanos estadounidenses o residentes permanentes."
        },
        {
          title: "Servicios VAWA y Términos Clave",
          items: [
            "Ley de Violencia Contra las Mujeres (VAWA): Ley federal que permite a cónyuges, hijos y padres maltratados auto-peticionar estatus migratorio",
            "Formulario I-360: Petición para Amerasiano, Viudo(a) o Inmigrante Especial usado para auto-peticiones VAWA",
            "Auto-petición: Permite a la víctima peticionar residencia permanente independientemente sin conocimiento o cooperación del agresor",
            "Agresión o Crueldad Extrema: Violencia física, abuso sexual o abuso psicológico extremo que constituye abuso calificado",
            "Relación Calificada: Debe ser cónyuge, hijo o padre de agresor ciudadano estadounidense o residente permanente legal",
            "Buen Carácter Moral: El peticionario VAWA debe demostrar buen carácter moral durante 3 años antes de presentar",
            "Matrimonio de Buena Fe: Para peticionarios cónyuges, debe mostrar que el matrimonio se celebró de buena fe, no únicamente para beneficios migratorios",
            "Requisito de Residencia: Debe haber residido con el agresor en algún momento durante la relación",
            "Determinación Prima Facie: Hallazgo inicial de USCIS de que la petición es aprobable, activa elegibilidad para ciertos beneficios públicos",
            "Protecciones de Confidencialidad: USCIS tiene prohibido divulgar información sobre la petición VAWA al agresor",
            "Beneficiarios Derivados: Hijos menores de 21 pueden ser incluidos en la petición VAWA del padre o presentar su propia petición",
            "Cancelación de Remoción: Alivio especial de la corte de inmigración para peticionarios VAWA en procedimientos de remoción",
            "Autorización de Trabajo: Los peticionarios VAWA pueden solicitar autorización de empleo mientras la petición está pendiente",
            "Ajuste de Estatus: Después de la aprobación de VAWA, puede solicitar tarjeta verde mediante Formulario I-485",
            "Elegibilidad para Beneficios Públicos: Peticionarios VAWA prima facie elegibles para ciertos beneficios federales y estatales"
          ]
        }
      ],
      faq: [
        {
          question: "¿Sabrá mi agresor que presenté una petición VAWA?",
          answer: "No. USCIS mantiene estricta confidencialidad y está prohibido por ley divulgar cualquier información sobre su petición VAWA a su agresor. Su petición se procesa independientemente."
        },
        {
          question: "¿Pueden los hombres presentar peticiones VAWA?",
          answer: "Sí, a pesar del nombre, las protecciones VAWA están disponibles para todas las víctimas de violencia doméstica independientemente del género. Las víctimas masculinas de abuso por parte de cónyuges o padres ciudadanos estadounidenses o residentes permanentes pueden presentar auto-peticiones VAWA."
        },
        {
          question: "¿Qué evidencia necesito para VAWA?",
          answer: "La evidencia incluye prueba de relación calificada (certificado de matrimonio, certificado de nacimiento), prueba del estatus del agresor, evidencia de abuso (informes policiales, registros médicos, órdenes de protección, fotos, declaraciones de testigos) y evidencia de buen carácter moral."
        },
        {
          question: "¿Cuánto tiempo toma el proceso VAWA?",
          answer: "El procesamiento de peticiones VAWA típicamente toma 24-36 meses. Sin embargo, puede solicitar autorización de trabajo mientras su petición está pendiente y puede recibir una determinación prima facie que le brinda acceso a ciertos beneficios públicos."
        }
      ]
    },
    vi: { 
      title: "Đơn VAWA", 
      subtitle: "Tự nộp đơn cho vợ/chồng và con bị lạm dụng", 
      sections: [
        { 
          title: "Dịch Vụ VAWA", 
          content: "Đạo luật Chống Bạo lực Phụ Nữ cho phép nạn nhân bạo lực gia đình tự nộp đơn xin tình trạng di trú mà không cần người lạm dụng biết. Bảo vệ VAWA có sẵn cho cả phụ nữ và nam giới là nạn nhân lạm dụng bởi vợ/chồng hoặc cha mẹ là công dân Mỹ hoặc thường trú nhân."
        },
        {
          title: "Dịch Vụ VAWA & Thuật Ngữ Chính",
          items: [
            "Đạo Luật Chống Bạo Lực Phụ Nữ (VAWA): Luật liên bang cho phép vợ/chồng, con cái và cha mẹ bị lạm dụng tự nộp đơn xin tình trạng di trú",
            "Mẫu I-360: Đơn Xin Cho Người Mỹ-Á, Góa Phụ/Góa Chồng hoặc Người Nhập Cư Đặc Biệt được sử dụng cho đơn tự nộp VAWA",
            "Tự Nộp Đơn: Cho phép nạn nhân nộp đơn xin thường trú một cách độc lập mà không cần sự biết hoặc hợp tác của người lạm dụng",
            "Đánh Đập hoặc Độc Ác Cực Độ: Bạo lực thể chất, lạm dụng tình dục hoặc lạm dụng tâm lý cực độ cấu thành lạm dụng đủ điều kiện",
            "Mối Quan Hệ Đủ Điều Kiện: Phải là vợ/chồng, con hoặc cha mẹ của người lạm dụng là công dân Mỹ hoặc thường trú nhân hợp pháp",
            "Phẩm Chất Đạo Đức Tốt: Người đệ đơn VAWA phải chứng minh phẩm chất đạo đức tốt trong 3 năm trước khi nộp đơn",
            "Hôn Nhân Thiện Chí: Đối với người đệ đơn là vợ/chồng, phải cho thấy hôn nhân được kết hợp với thiện chí, không chỉ vì lợi ích di trú",
            "Yêu Cầu Cư Trú: Phải đã sống với người lạm dụng tại một thời điểm nào đó trong mối quan hệ",
            "Xác Định Bề Mặt: Phát hiện ban đầu của USCIS rằng đơn có thể phê duyệt, kích hoạt đủ điều kiện cho một số quyền lợi công cộng nhất định",
            "Bảo Vệ Bảo Mật: USCIS bị cấm tiết lộ thông tin về đơn VAWA cho người lạm dụng",
            "Người Thụ Hưởng Phái Sinh: Trẻ em dưới 21 tuổi có thể được bao gồm trong đơn VAWA của cha mẹ hoặc nộp đơn riêng của mình",
            "Hủy Bỏ Di Dời: Cứu trợ đặc biệt của tòa án di trú cho người đệ đơn VAWA trong thủ tục di dời",
            "Giấy Phép Làm Việc: Người đệ đơn VAWA có thể nộp đơn xin giấy phép làm việc trong khi đơn đang chờ xử lý",
            "Điều Chỉnh Tình Trạng: Sau khi VAWA được phê duyệt, có thể nộp đơn xin thẻ xanh thông qua Mẫu I-485",
            "Đủ Điều Kiện Quyền Lợi Công Cộng: Người đệ đơn VAWA bề mặt đủ điều kiện cho một số quyền lợi liên bang và tiểu bang nhất định"
          ]
        }
      ],
      faq: [
        {
          question: "Người lạm dụng tôi có biết tôi nộp đơn VAWA không?",
          answer: "Không. USCIS duy trì bảo mật nghiêm ngặt và bị luật cấm tiết lộ bất kỳ thông tin nào về đơn VAWA của bạn cho người lạm dụng. Đơn của bạn được xử lý độc lập."
        },
        {
          question: "Nam giới có thể nộp đơn VAWA không?",
          answer: "Có, mặc dù tên gọi, bảo vệ VAWA có sẵn cho tất cả nạn nhân bạo lực gia đình bất kể giới tính. Nạn nhân nam của lạm dụng bởi vợ/chồng hoặc cha mẹ là công dân Mỹ hoặc thường trú nhân có thể nộp đơn tự nộp VAWA."
        },
        {
          question: "Tôi cần bằng chứng gì cho VAWA?",
          answer: "Bằng chứng bao gồm chứng minh mối quan hệ đủ điều kiện (giấy chứng nhận kết hôn, giấy khai sinh), chứng minh tình trạng của người lạm dụng, bằng chứng lạm dụng (báo cáo cảnh sát, hồ sơ y tế, lệnh bảo vệ, ảnh, tuyên bố của nhân chứng) và bằng chứng phẩm chất đạo đức tốt."
        },
        {
          question: "Quy trình VAWA mất bao lâu?",
          answer: "Xử lý đơn VAWA thường mất 24-36 tháng. Tuy nhiên, bạn có thể nộp đơn xin giấy phép làm việc trong khi đơn của bạn đang chờ xử lý và có thể nhận được xác định bề mặt cung cấp cho bạn quyền truy cập vào một số quyền lợi công cộng nhất định."
        }
      ]
    }
  }
};
